// Every 10 min = 4320 a month
// Every 1 sec = 2.5M a month

const RoomRight = {
  "Items": [
    {
      "device_data": {
        "temp": "2116"
      },
      "createdOnTime": 1668017090,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1877"
      },
      "createdOnTime": 1668017690,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1937"
      },
      "createdOnTime": 1668018290,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1963"
      },
      "createdOnTime": 1668018890,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1945"
      },
      "createdOnTime": 1668019491,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1949"
      },
      "createdOnTime": 1668020091,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1949"
      },
      "createdOnTime": 1668020691,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1962"
      },
      "createdOnTime": 1668021291,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1967"
      },
      "createdOnTime": 1668021891,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1978"
      },
      "createdOnTime": 1668022491,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1984"
      },
      "createdOnTime": 1668023091,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1990"
      },
      "createdOnTime": 1668023691,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1994"
      },
      "createdOnTime": 1668024291,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2018"
      },
      "createdOnTime": 1668024891,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2030"
      },
      "createdOnTime": 1668025491,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2036"
      },
      "createdOnTime": 1668026091,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2042"
      },
      "createdOnTime": 1668026692,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2058"
      },
      "createdOnTime": 1668027292,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2058"
      },
      "createdOnTime": 1668027892,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2063"
      },
      "createdOnTime": 1668028492,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2074"
      },
      "createdOnTime": 1668029092,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2096"
      },
      "createdOnTime": 1668029692,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2113"
      },
      "createdOnTime": 1668030292,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2127"
      },
      "createdOnTime": 1668030892,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2134"
      },
      "createdOnTime": 1668031492,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2144"
      },
      "createdOnTime": 1668032092,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2165"
      },
      "createdOnTime": 1668032692,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2175"
      },
      "createdOnTime": 1668033292,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2185"
      },
      "createdOnTime": 1668033892,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2200"
      },
      "createdOnTime": 1668034492,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2226"
      },
      "createdOnTime": 1668035092,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2239"
      },
      "createdOnTime": 1668035693,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2257"
      },
      "createdOnTime": 1668036293,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2265"
      },
      "createdOnTime": 1668036893,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1928"
      },
      "createdOnTime": 1668102405,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1919"
      },
      "createdOnTime": 1668103005,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2084"
      },
      "createdOnTime": 1668103605,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2208"
      },
      "createdOnTime": 1668104206,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2274"
      },
      "createdOnTime": 1668104806,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2380"
      },
      "createdOnTime": 1668105406,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2459"
      },
      "createdOnTime": 1668106006,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2520"
      },
      "createdOnTime": 1668106606,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2561"
      },
      "createdOnTime": 1668107206,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2537"
      },
      "createdOnTime": 1668107806,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2413"
      },
      "createdOnTime": 1668108406,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2298"
      },
      "createdOnTime": 1668109006,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2222"
      },
      "createdOnTime": 1668109606,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2165"
      },
      "createdOnTime": 1668110206,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2116"
      },
      "createdOnTime": 1668110806,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2082"
      },
      "createdOnTime": 1668111406,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2048"
      },
      "createdOnTime": 1668112006,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2032"
      },
      "createdOnTime": 1668112606,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2020"
      },
      "createdOnTime": 1668113207,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2013"
      },
      "createdOnTime": 1668113807,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2014"
      },
      "createdOnTime": 1668114407,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2021"
      },
      "createdOnTime": 1668115007,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2026"
      },
      "createdOnTime": 1668115607,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2026"
      },
      "createdOnTime": 1668116207,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2033"
      },
      "createdOnTime": 1668116807,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2053"
      },
      "createdOnTime": 1668117407,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2047"
      },
      "createdOnTime": 1668118007,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2048"
      },
      "createdOnTime": 1668118607,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2053"
      },
      "createdOnTime": 1668119207,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2057"
      },
      "createdOnTime": 1668119807,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2062"
      },
      "createdOnTime": 1668120407,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2081"
      },
      "createdOnTime": 1668121008,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2087"
      },
      "createdOnTime": 1668121608,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2083"
      },
      "createdOnTime": 1668122208,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2093"
      },
      "createdOnTime": 1668122808,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2102"
      },
      "createdOnTime": 1668123408,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2120"
      },
      "createdOnTime": 1668124008,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2132"
      },
      "createdOnTime": 1668124608,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2132"
      },
      "createdOnTime": 1668125208,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2125"
      },
      "createdOnTime": 1668125808,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2140"
      },
      "createdOnTime": 1668126408,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2140"
      },
      "createdOnTime": 1668127008,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2153"
      },
      "createdOnTime": 1668127608,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2168"
      },
      "createdOnTime": 1668128208,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2181"
      },
      "createdOnTime": 1668128808,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2186"
      },
      "createdOnTime": 1668129409,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2013"
      },
      "createdOnTime": 1668283893,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2002"
      },
      "createdOnTime": 1668284493,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2157"
      },
      "createdOnTime": 1668285093,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2202"
      },
      "createdOnTime": 1668285693,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2135"
      },
      "createdOnTime": 1668286293,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2127"
      },
      "createdOnTime": 1668286893,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2124"
      },
      "createdOnTime": 1668287493,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2117"
      },
      "createdOnTime": 1668288093,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2114"
      },
      "createdOnTime": 1668288693,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2111"
      },
      "createdOnTime": 1668289293,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2110"
      },
      "createdOnTime": 1668289893,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2108"
      },
      "createdOnTime": 1668290493,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2117"
      },
      "createdOnTime": 1668291093,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2126"
      },
      "createdOnTime": 1668291693,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2131"
      },
      "createdOnTime": 1668292293,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2136"
      },
      "createdOnTime": 1668292894,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2142"
      },
      "createdOnTime": 1668293494,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2130"
      },
      "createdOnTime": 1668294094,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2129"
      },
      "createdOnTime": 1668294694,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2131"
      },
      "createdOnTime": 1668295294,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2129"
      },
      "createdOnTime": 1668295894,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2136"
      },
      "createdOnTime": 1668296494,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2138"
      },
      "createdOnTime": 1668297094,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2155"
      },
      "createdOnTime": 1668297694,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2163"
      },
      "createdOnTime": 1668298294,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2169"
      },
      "createdOnTime": 1668298894,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2170"
      },
      "createdOnTime": 1668299494,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2185"
      },
      "createdOnTime": 1668300094,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2175"
      },
      "createdOnTime": 1668300694,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2171"
      },
      "createdOnTime": 1668301295,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2172"
      },
      "createdOnTime": 1668301895,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2183"
      },
      "createdOnTime": 1668302495,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2188"
      },
      "createdOnTime": 1668303095,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2189"
      },
      "createdOnTime": 1668303695,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2195"
      },
      "createdOnTime": 1668304295,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2188"
      },
      "createdOnTime": 1668304895,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2198"
      },
      "createdOnTime": 1668305495,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2204"
      },
      "createdOnTime": 1668306095,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2205"
      },
      "createdOnTime": 1668306695,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2213"
      },
      "createdOnTime": 1668307295,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2216"
      },
      "createdOnTime": 1668307895,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2220"
      },
      "createdOnTime": 1668308495,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2222"
      },
      "createdOnTime": 1668309095,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2227"
      },
      "createdOnTime": 1668309696,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2234"
      },
      "createdOnTime": 1668310296,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2230"
      },
      "createdOnTime": 1668310896,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2230"
      },
      "createdOnTime": 1668311496,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2228"
      },
      "createdOnTime": 1668312096,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2227"
      },
      "createdOnTime": 1668312696,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2228"
      },
      "createdOnTime": 1668313296,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2231"
      },
      "createdOnTime": 1668313896,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2241"
      },
      "createdOnTime": 1668314496,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2281"
      },
      "createdOnTime": 1668315096,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2305"
      },
      "createdOnTime": 1668315696,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2321"
      },
      "createdOnTime": 1668316296,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2320"
      },
      "createdOnTime": 1668316896,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2337"
      },
      "createdOnTime": 1668317497,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2364"
      },
      "createdOnTime": 1668318097,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2343"
      },
      "createdOnTime": 1668318697,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2335"
      },
      "createdOnTime": 1668319297,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2339"
      },
      "createdOnTime": 1668319897,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2351"
      },
      "createdOnTime": 1668320497,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2350"
      },
      "createdOnTime": 1668321097,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2345"
      },
      "createdOnTime": 1668321697,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2330"
      },
      "createdOnTime": 1668322297,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2315"
      },
      "createdOnTime": 1668322897,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2301"
      },
      "createdOnTime": 1668323497,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2285"
      },
      "createdOnTime": 1668324097,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2274"
      },
      "createdOnTime": 1668324697,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2252"
      },
      "createdOnTime": 1668325298,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2235"
      },
      "createdOnTime": 1668325898,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2226"
      },
      "createdOnTime": 1668326498,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2210"
      },
      "createdOnTime": 1668327098,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2190"
      },
      "createdOnTime": 1668327698,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2182"
      },
      "createdOnTime": 1668328298,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2168"
      },
      "createdOnTime": 1668328898,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2158"
      },
      "createdOnTime": 1668329498,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2147"
      },
      "createdOnTime": 1668330098,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2137"
      },
      "createdOnTime": 1668330698,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2131"
      },
      "createdOnTime": 1668331298,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2124"
      },
      "createdOnTime": 1668331898,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2117"
      },
      "createdOnTime": 1668332498,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2109"
      },
      "createdOnTime": 1668333099,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2099"
      },
      "createdOnTime": 1668333699,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2086"
      },
      "createdOnTime": 1668334299,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2078"
      },
      "createdOnTime": 1668334899,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2075"
      },
      "createdOnTime": 1668335499,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2068"
      },
      "createdOnTime": 1668336099,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2058"
      },
      "createdOnTime": 1668336699,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2050"
      },
      "createdOnTime": 1668337299,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2036"
      },
      "createdOnTime": 1668337899,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2030"
      },
      "createdOnTime": 1668338499,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2020"
      },
      "createdOnTime": 1668339099,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2015"
      },
      "createdOnTime": 1668339699,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "2003"
      },
      "createdOnTime": 1668340299,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1996"
      },
      "createdOnTime": 1668340899,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1989"
      },
      "createdOnTime": 1668341499,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1981"
      },
      "createdOnTime": 1668342100,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1974"
      },
      "createdOnTime": 1668342700,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1965"
      },
      "createdOnTime": 1668343300,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1959"
      },
      "createdOnTime": 1668343900,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1946"
      },
      "createdOnTime": 1668344500,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1941"
      },
      "createdOnTime": 1668345100,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1936"
      },
      "createdOnTime": 1668345700,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1928"
      },
      "createdOnTime": 1668346300,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1921"
      },
      "createdOnTime": 1668346900,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1912"
      },
      "createdOnTime": 1668347500,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1904"
      },
      "createdOnTime": 1668348100,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1896"
      },
      "createdOnTime": 1668348700,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1891"
      },
      "createdOnTime": 1668349300,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1885"
      },
      "createdOnTime": 1668349900,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1881"
      },
      "createdOnTime": 1668350500,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1879"
      },
      "createdOnTime": 1668351101,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1876"
      },
      "createdOnTime": 1668351701,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1868"
      },
      "createdOnTime": 1668352301,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1865"
      },
      "createdOnTime": 1668352901,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1859"
      },
      "createdOnTime": 1668353501,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1851"
      },
      "createdOnTime": 1668354101,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1836"
      },
      "createdOnTime": 1668354701,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1831"
      },
      "createdOnTime": 1668355301,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1826"
      },
      "createdOnTime": 1668355901,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1825"
      },
      "createdOnTime": 1668356501,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1820"
      },
      "createdOnTime": 1668357101,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1812"
      },
      "createdOnTime": 1668357701,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1808"
      },
      "createdOnTime": 1668358301,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1803"
      },
      "createdOnTime": 1668358901,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1804"
      },
      "createdOnTime": 1668359502,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1797"
      },
      "createdOnTime": 1668360102,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1790"
      },
      "createdOnTime": 1668360702,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1786"
      },
      "createdOnTime": 1668361302,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1791"
      },
      "createdOnTime": 1668361902,
      "deviceId": "EC:94:CB:79:C8:D4"
    },
    {
      "device_data": {
        "temp": "1805"
      },
      "createdOnTime": 1668362502,
      "deviceId": "EC:94:CB:79:C8:D4"
    }
  ],
  "Count": 212,
  "ScannedCount": 212
}

const RoomLeft = {
  "Items": [
    {
      "device_data": {
        "temp": "2043"
      },
      "createdOnTime": 1667867850,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2027"
      },
      "createdOnTime": 1667868450,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2036"
      },
      "createdOnTime": 1667869050,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2040"
      },
      "createdOnTime": 1667869650,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2037"
      },
      "createdOnTime": 1667870251,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2033"
      },
      "createdOnTime": 1667870851,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2042"
      },
      "createdOnTime": 1667871451,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1979"
      },
      "createdOnTime": 1667872051,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1996"
      },
      "createdOnTime": 1667872651,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2009"
      },
      "createdOnTime": 1667873251,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2023"
      },
      "createdOnTime": 1667873851,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2034"
      },
      "createdOnTime": 1667874451,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2048"
      },
      "createdOnTime": 1667875051,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2049"
      },
      "createdOnTime": 1667875651,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1977"
      },
      "createdOnTime": 1667876251,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1972"
      },
      "createdOnTime": 1667876851,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1981"
      },
      "createdOnTime": 1667877451,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1994"
      },
      "createdOnTime": 1667878051,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1999"
      },
      "createdOnTime": 1667878652,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2003"
      },
      "createdOnTime": 1667879252,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2013"
      },
      "createdOnTime": 1667879852,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2018"
      },
      "createdOnTime": 1667880452,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1962"
      },
      "createdOnTime": 1667881052,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1959"
      },
      "createdOnTime": 1667881652,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1962"
      },
      "createdOnTime": 1667882252,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1976"
      },
      "createdOnTime": 1667882852,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1988"
      },
      "createdOnTime": 1667883452,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1984"
      },
      "createdOnTime": 1667884052,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1995"
      },
      "createdOnTime": 1667884652,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2008"
      },
      "createdOnTime": 1667885252,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1932"
      },
      "createdOnTime": 1667885852,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1933"
      },
      "createdOnTime": 1667886452,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1934"
      },
      "createdOnTime": 1667887053,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1939"
      },
      "createdOnTime": 1667887653,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1938"
      },
      "createdOnTime": 1667888253,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1952"
      },
      "createdOnTime": 1667888853,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1950"
      },
      "createdOnTime": 1667889453,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1951"
      },
      "createdOnTime": 1667890053,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1873"
      },
      "createdOnTime": 1667890653,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1875"
      },
      "createdOnTime": 1667891253,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1873"
      },
      "createdOnTime": 1667891853,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1877"
      },
      "createdOnTime": 1667892453,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1882"
      },
      "createdOnTime": 1667893053,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1888"
      },
      "createdOnTime": 1667893653,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1891"
      },
      "createdOnTime": 1667894253,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1815"
      },
      "createdOnTime": 1667894853,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1822"
      },
      "createdOnTime": 1667895454,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1825"
      },
      "createdOnTime": 1667896054,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1835"
      },
      "createdOnTime": 1667896654,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1838"
      },
      "createdOnTime": 1667897254,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1844"
      },
      "createdOnTime": 1667897854,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1848"
      },
      "createdOnTime": 1667898454,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1857"
      },
      "createdOnTime": 1667899054,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1788"
      },
      "createdOnTime": 1667899654,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1795"
      },
      "createdOnTime": 1667900254,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1803"
      },
      "createdOnTime": 1667900854,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1806"
      },
      "createdOnTime": 1667901454,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1811"
      },
      "createdOnTime": 1667902054,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1814"
      },
      "createdOnTime": 1667902654,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1819"
      },
      "createdOnTime": 1667903254,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1828"
      },
      "createdOnTime": 1667903854,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1753"
      },
      "createdOnTime": 1667904455,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1760"
      },
      "createdOnTime": 1667905055,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1767"
      },
      "createdOnTime": 1667905655,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1775"
      },
      "createdOnTime": 1667906255,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1781"
      },
      "createdOnTime": 1667906855,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1791"
      },
      "createdOnTime": 1667907455,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1799"
      },
      "createdOnTime": 1667908055,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1728"
      },
      "createdOnTime": 1667908655,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1734"
      },
      "createdOnTime": 1667909255,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1742"
      },
      "createdOnTime": 1667909855,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1746"
      },
      "createdOnTime": 1667910455,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1747"
      },
      "createdOnTime": 1667911055,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1760"
      },
      "createdOnTime": 1667911655,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1762"
      },
      "createdOnTime": 1667912255,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1776"
      },
      "createdOnTime": 1667912855,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1707"
      },
      "createdOnTime": 1667913456,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1715"
      },
      "createdOnTime": 1667914056,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1721"
      },
      "createdOnTime": 1667914656,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1727"
      },
      "createdOnTime": 1667915256,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1735"
      },
      "createdOnTime": 1667915856,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1739"
      },
      "createdOnTime": 1667916456,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1752"
      },
      "createdOnTime": 1667917056,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1760"
      },
      "createdOnTime": 1667917656,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1687"
      },
      "createdOnTime": 1667918256,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1695"
      },
      "createdOnTime": 1667918856,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1706"
      },
      "createdOnTime": 1667919456,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1711"
      },
      "createdOnTime": 1667920056,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1719"
      },
      "createdOnTime": 1667920656,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1727"
      },
      "createdOnTime": 1667921257,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1731"
      },
      "createdOnTime": 1667921857,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1736"
      },
      "createdOnTime": 1667922457,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1667"
      },
      "createdOnTime": 1667923057,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1673"
      },
      "createdOnTime": 1667923657,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1685"
      },
      "createdOnTime": 1667924257,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1695"
      },
      "createdOnTime": 1667924857,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1706"
      },
      "createdOnTime": 1667925457,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1713"
      },
      "createdOnTime": 1667926057,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1723"
      },
      "createdOnTime": 1667926657,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1659"
      },
      "createdOnTime": 1667927257,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1670"
      },
      "createdOnTime": 1667927857,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1685"
      },
      "createdOnTime": 1667928457,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1689"
      },
      "createdOnTime": 1667929057,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1704"
      },
      "createdOnTime": 1667929657,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1716"
      },
      "createdOnTime": 1667930258,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1727"
      },
      "createdOnTime": 1667930858,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1741"
      },
      "createdOnTime": 1667931458,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1682"
      },
      "createdOnTime": 1667932058,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1707"
      },
      "createdOnTime": 1667932658,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1737"
      },
      "createdOnTime": 1667933258,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1927"
      },
      "createdOnTime": 1668016162,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1712"
      },
      "createdOnTime": 1668016762,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1741"
      },
      "createdOnTime": 1668017362,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1813"
      },
      "createdOnTime": 1668017962,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1858"
      },
      "createdOnTime": 1668018562,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1895"
      },
      "createdOnTime": 1668019163,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1920"
      },
      "createdOnTime": 1668019763,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1942"
      },
      "createdOnTime": 1668020363,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1964"
      },
      "createdOnTime": 1668020963,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1979"
      },
      "createdOnTime": 1668021563,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1927"
      },
      "createdOnTime": 1668022163,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1942"
      },
      "createdOnTime": 1668022763,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1964"
      },
      "createdOnTime": 1668023363,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1982"
      },
      "createdOnTime": 1668023963,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1997"
      },
      "createdOnTime": 1668024563,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2018"
      },
      "createdOnTime": 1668025163,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2039"
      },
      "createdOnTime": 1668025763,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2061"
      },
      "createdOnTime": 1668026371,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2012"
      },
      "createdOnTime": 1668026971,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2024"
      },
      "createdOnTime": 1668027571,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2035"
      },
      "createdOnTime": 1668028172,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2054"
      },
      "createdOnTime": 1668028772,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2070"
      },
      "createdOnTime": 1668029372,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2089"
      },
      "createdOnTime": 1668029972,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2119"
      },
      "createdOnTime": 1668030572,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2143"
      },
      "createdOnTime": 1668031172,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2093"
      },
      "createdOnTime": 1668031772,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2125"
      },
      "createdOnTime": 1668032372,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2149"
      },
      "createdOnTime": 1668032972,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2171"
      },
      "createdOnTime": 1668033572,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2197"
      },
      "createdOnTime": 1668034172,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2218"
      },
      "createdOnTime": 1668034772,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2245"
      },
      "createdOnTime": 1668035372,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2192"
      },
      "createdOnTime": 1668035972,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2211"
      },
      "createdOnTime": 1668036572,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2231"
      },
      "createdOnTime": 1668037173,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1877"
      },
      "createdOnTime": 1668103221,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1728"
      },
      "createdOnTime": 1668103821,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1805"
      },
      "createdOnTime": 1668104421,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1901"
      },
      "createdOnTime": 1668105021,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1979"
      },
      "createdOnTime": 1668105621,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2041"
      },
      "createdOnTime": 1668106221,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2092"
      },
      "createdOnTime": 1668106821,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2132"
      },
      "createdOnTime": 1668107421,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2146"
      },
      "createdOnTime": 1668108021,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2140"
      },
      "createdOnTime": 1668108621,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2041"
      },
      "createdOnTime": 1668109221,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2039"
      },
      "createdOnTime": 1668109821,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2026"
      },
      "createdOnTime": 1668110421,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2020"
      },
      "createdOnTime": 1668111022,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2017"
      },
      "createdOnTime": 1668111622,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2029"
      },
      "createdOnTime": 1668112222,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2004"
      },
      "createdOnTime": 1668112822,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2006"
      },
      "createdOnTime": 1668113422,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1939"
      },
      "createdOnTime": 1668114022,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1949"
      },
      "createdOnTime": 1668114622,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1962"
      },
      "createdOnTime": 1668115222,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1981"
      },
      "createdOnTime": 1668115822,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1999"
      },
      "createdOnTime": 1668116422,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2017"
      },
      "createdOnTime": 1668117022,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2039"
      },
      "createdOnTime": 1668117622,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2059"
      },
      "createdOnTime": 1668118222,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2007"
      },
      "createdOnTime": 1668118822,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2033"
      },
      "createdOnTime": 1668119423,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2054"
      },
      "createdOnTime": 1668120023,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2070"
      },
      "createdOnTime": 1668120623,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2109"
      },
      "createdOnTime": 1668121223,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2115"
      },
      "createdOnTime": 1668121823,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2145"
      },
      "createdOnTime": 1668122423,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2090"
      },
      "createdOnTime": 1668123023,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2116"
      },
      "createdOnTime": 1668123623,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2142"
      },
      "createdOnTime": 1668124223,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2163"
      },
      "createdOnTime": 1668124823,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2178"
      },
      "createdOnTime": 1668125423,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2193"
      },
      "createdOnTime": 1668126023,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2200"
      },
      "createdOnTime": 1668126623,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2209"
      },
      "createdOnTime": 1668127223,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2152"
      },
      "createdOnTime": 1668127824,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2169"
      },
      "createdOnTime": 1668128424,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2183"
      },
      "createdOnTime": 1668129024,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2207"
      },
      "createdOnTime": 1668129624,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2227"
      },
      "createdOnTime": 1668130224,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2246"
      },
      "createdOnTime": 1668130824,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2269"
      },
      "createdOnTime": 1668131424,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2284"
      },
      "createdOnTime": 1668132024,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2233"
      },
      "createdOnTime": 1668132624,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2251"
      },
      "createdOnTime": 1668133224,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2269"
      },
      "createdOnTime": 1668133824,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2294"
      },
      "createdOnTime": 1668134424,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2308"
      },
      "createdOnTime": 1668135024,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2329"
      },
      "createdOnTime": 1668135625,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2340"
      },
      "createdOnTime": 1668136225,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2272"
      },
      "createdOnTime": 1668136825,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2277"
      },
      "createdOnTime": 1668137425,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2286"
      },
      "createdOnTime": 1668138025,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2289"
      },
      "createdOnTime": 1668138625,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2298"
      },
      "createdOnTime": 1668139225,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2305"
      },
      "createdOnTime": 1668139825,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2311"
      },
      "createdOnTime": 1668140425,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2317"
      },
      "createdOnTime": 1668141025,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2249"
      },
      "createdOnTime": 1668141625,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2254"
      },
      "createdOnTime": 1668142226,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2266"
      },
      "createdOnTime": 1668142826,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2272"
      },
      "createdOnTime": 1668143426,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2279"
      },
      "createdOnTime": 1668144026,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2284"
      },
      "createdOnTime": 1668144626,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2294"
      },
      "createdOnTime": 1668145226,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2302"
      },
      "createdOnTime": 1668145826,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2236"
      },
      "createdOnTime": 1668146426,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2233"
      },
      "createdOnTime": 1668147026,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2226"
      },
      "createdOnTime": 1668147626,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2227"
      },
      "createdOnTime": 1668148226,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2229"
      },
      "createdOnTime": 1668148826,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2236"
      },
      "createdOnTime": 1668149426,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2236"
      },
      "createdOnTime": 1668150026,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2238"
      },
      "createdOnTime": 1668150626,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2166"
      },
      "createdOnTime": 1668151227,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2168"
      },
      "createdOnTime": 1668151827,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2172"
      },
      "createdOnTime": 1668152427,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2177"
      },
      "createdOnTime": 1668153027,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2185"
      },
      "createdOnTime": 1668153627,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2186"
      },
      "createdOnTime": 1668154227,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2193"
      },
      "createdOnTime": 1668154827,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2122"
      },
      "createdOnTime": 1668155427,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2124"
      },
      "createdOnTime": 1668156027,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2129"
      },
      "createdOnTime": 1668156627,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2132"
      },
      "createdOnTime": 1668157227,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2137"
      },
      "createdOnTime": 1668157827,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2141"
      },
      "createdOnTime": 1668158427,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2144"
      },
      "createdOnTime": 1668159027,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2153"
      },
      "createdOnTime": 1668159627,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2081"
      },
      "createdOnTime": 1668160228,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2087"
      },
      "createdOnTime": 1668160828,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2097"
      },
      "createdOnTime": 1668161428,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2108"
      },
      "createdOnTime": 1668162028,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2116"
      },
      "createdOnTime": 1668162628,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2123"
      },
      "createdOnTime": 1668163228,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2132"
      },
      "createdOnTime": 1668163828,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2145"
      },
      "createdOnTime": 1668164428,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2066"
      },
      "createdOnTime": 1668165028,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2077"
      },
      "createdOnTime": 1668165628,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2083"
      },
      "createdOnTime": 1668166228,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2091"
      },
      "createdOnTime": 1668166828,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2097"
      },
      "createdOnTime": 1668167428,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2103"
      },
      "createdOnTime": 1668168028,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2110"
      },
      "createdOnTime": 1668168628,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2041"
      },
      "createdOnTime": 1668169229,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2047"
      },
      "createdOnTime": 1668169829,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2055"
      },
      "createdOnTime": 1668170429,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2061"
      },
      "createdOnTime": 1668171029,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2069"
      },
      "createdOnTime": 1668171629,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2078"
      },
      "createdOnTime": 1668172229,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2081"
      },
      "createdOnTime": 1668172829,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2090"
      },
      "createdOnTime": 1668173429,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2015"
      },
      "createdOnTime": 1668174029,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2024"
      },
      "createdOnTime": 1668174629,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2035"
      },
      "createdOnTime": 1668175229,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2039"
      },
      "createdOnTime": 1668175829,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2047"
      },
      "createdOnTime": 1668176429,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2054"
      },
      "createdOnTime": 1668177029,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2059"
      },
      "createdOnTime": 1668177629,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2061"
      },
      "createdOnTime": 1668178229,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1994"
      },
      "createdOnTime": 1668178830,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2005"
      },
      "createdOnTime": 1668179430,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2010"
      },
      "createdOnTime": 1668180030,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2020"
      },
      "createdOnTime": 1668180630,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2031"
      },
      "createdOnTime": 1668181230,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2036"
      },
      "createdOnTime": 1668181830,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2040"
      },
      "createdOnTime": 1668182430,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1976"
      },
      "createdOnTime": 1668183030,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1976"
      },
      "createdOnTime": 1668183630,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1987"
      },
      "createdOnTime": 1668184230,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1994"
      },
      "createdOnTime": 1668184830,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1995"
      },
      "createdOnTime": 1668185430,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2003"
      },
      "createdOnTime": 1668186030,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2004"
      },
      "createdOnTime": 1668186631,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2014"
      },
      "createdOnTime": 1668187231,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1939"
      },
      "createdOnTime": 1668187831,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1948"
      },
      "createdOnTime": 1668188431,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1958"
      },
      "createdOnTime": 1668189031,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1964"
      },
      "createdOnTime": 1668189631,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1973"
      },
      "createdOnTime": 1668190231,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1983"
      },
      "createdOnTime": 1668190831,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1992"
      },
      "createdOnTime": 1668191431,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2005"
      },
      "createdOnTime": 1668192031,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1939"
      },
      "createdOnTime": 1668192631,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1953"
      },
      "createdOnTime": 1668193231,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1971"
      },
      "createdOnTime": 1668193831,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1991"
      },
      "createdOnTime": 1668194431,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2009"
      },
      "createdOnTime": 1668195031,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2032"
      },
      "createdOnTime": 1668195632,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2049"
      },
      "createdOnTime": 1668196232,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2075"
      },
      "createdOnTime": 1668196832,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2017"
      },
      "createdOnTime": 1668197432,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2033"
      },
      "createdOnTime": 1668198032,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2049"
      },
      "createdOnTime": 1668198632,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2058"
      },
      "createdOnTime": 1668199232,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2069"
      },
      "createdOnTime": 1668199832,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2085"
      },
      "createdOnTime": 1668200432,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2100"
      },
      "createdOnTime": 1668201032,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2043"
      },
      "createdOnTime": 1668201632,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2067"
      },
      "createdOnTime": 1668202232,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2094"
      },
      "createdOnTime": 1668202832,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2111"
      },
      "createdOnTime": 1668203432,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2129"
      },
      "createdOnTime": 1668204033,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2156"
      },
      "createdOnTime": 1668204633,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2172"
      },
      "createdOnTime": 1668205233,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2195"
      },
      "createdOnTime": 1668205833,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2134"
      },
      "createdOnTime": 1668206433,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2154"
      },
      "createdOnTime": 1668207033,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2176"
      },
      "createdOnTime": 1668207633,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2199"
      },
      "createdOnTime": 1668208233,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2227"
      },
      "createdOnTime": 1668208833,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2240"
      },
      "createdOnTime": 1668209433,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2260"
      },
      "createdOnTime": 1668210033,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2281"
      },
      "createdOnTime": 1668210633,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2225"
      },
      "createdOnTime": 1668211233,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2244"
      },
      "createdOnTime": 1668211833,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2261"
      },
      "createdOnTime": 1668212433,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2280"
      },
      "createdOnTime": 1668213034,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2301"
      },
      "createdOnTime": 1668213634,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2329"
      },
      "createdOnTime": 1668214234,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2351"
      },
      "createdOnTime": 1668214834,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2301"
      },
      "createdOnTime": 1668215434,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2331"
      },
      "createdOnTime": 1668216034,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2356"
      },
      "createdOnTime": 1668216634,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2366"
      },
      "createdOnTime": 1668217234,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2389"
      },
      "createdOnTime": 1668217834,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2408"
      },
      "createdOnTime": 1668218434,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2432"
      },
      "createdOnTime": 1668219034,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2461"
      },
      "createdOnTime": 1668219634,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2414"
      },
      "createdOnTime": 1668220234,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2445"
      },
      "createdOnTime": 1668220834,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2466"
      },
      "createdOnTime": 1668221435,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2492"
      },
      "createdOnTime": 1668222035,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2521"
      },
      "createdOnTime": 1668222635,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2551"
      },
      "createdOnTime": 1668223235,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2579"
      },
      "createdOnTime": 1668223835,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2611"
      },
      "createdOnTime": 1668224435,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2568"
      },
      "createdOnTime": 1668225035,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2601"
      },
      "createdOnTime": 1668225635,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2632"
      },
      "createdOnTime": 1668226235,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2661"
      },
      "createdOnTime": 1668226835,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2687"
      },
      "createdOnTime": 1668227435,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2715"
      },
      "createdOnTime": 1668228035,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2744"
      },
      "createdOnTime": 1668228635,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2758"
      },
      "createdOnTime": 1668229235,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2694"
      },
      "createdOnTime": 1668229835,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2680"
      },
      "createdOnTime": 1668230435,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2684"
      },
      "createdOnTime": 1668231036,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2684"
      },
      "createdOnTime": 1668231636,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2703"
      },
      "createdOnTime": 1668232236,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2700"
      },
      "createdOnTime": 1668232836,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2673"
      },
      "createdOnTime": 1668233436,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2577"
      },
      "createdOnTime": 1668234036,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2561"
      },
      "createdOnTime": 1668234636,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2531"
      },
      "createdOnTime": 1668235236,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2497"
      },
      "createdOnTime": 1668235836,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2492"
      },
      "createdOnTime": 1668236436,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2471"
      },
      "createdOnTime": 1668237036,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2459"
      },
      "createdOnTime": 1668237636,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1881"
      },
      "createdOnTime": 1668277703,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1675"
      },
      "createdOnTime": 1668278303,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1709"
      },
      "createdOnTime": 1668278903,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1782"
      },
      "createdOnTime": 1668279503,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1823"
      },
      "createdOnTime": 1668280103,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1855"
      },
      "createdOnTime": 1668280703,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1872"
      },
      "createdOnTime": 1668281303,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1895"
      },
      "createdOnTime": 1668281903,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1922"
      },
      "createdOnTime": 1668282503,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1950"
      },
      "createdOnTime": 1668283103,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1896"
      },
      "createdOnTime": 1668283704,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1926"
      },
      "createdOnTime": 1668284304,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1986"
      },
      "createdOnTime": 1668284904,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2050"
      },
      "createdOnTime": 1668285504,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2082"
      },
      "createdOnTime": 1668286104,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2107"
      },
      "createdOnTime": 1668286704,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2124"
      },
      "createdOnTime": 1668287304,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2137"
      },
      "createdOnTime": 1668287904,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2071"
      },
      "createdOnTime": 1668288504,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2086"
      },
      "createdOnTime": 1668289104,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2101"
      },
      "createdOnTime": 1668289704,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2111"
      },
      "createdOnTime": 1668290304,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2125"
      },
      "createdOnTime": 1668290904,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2138"
      },
      "createdOnTime": 1668291504,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2159"
      },
      "createdOnTime": 1668292104,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2182"
      },
      "createdOnTime": 1668292705,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2175"
      },
      "createdOnTime": 1668293305,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2142"
      },
      "createdOnTime": 1668293905,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2156"
      },
      "createdOnTime": 1668294505,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2170"
      },
      "createdOnTime": 1668295105,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2182"
      },
      "createdOnTime": 1668295705,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2200"
      },
      "createdOnTime": 1668296305,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2221"
      },
      "createdOnTime": 1668296905,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2167"
      },
      "createdOnTime": 1668297505,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2185"
      },
      "createdOnTime": 1668298105,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2206"
      },
      "createdOnTime": 1668298705,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2218"
      },
      "createdOnTime": 1668299305,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2226"
      },
      "createdOnTime": 1668299905,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2243"
      },
      "createdOnTime": 1668300505,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2249"
      },
      "createdOnTime": 1668301105,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2258"
      },
      "createdOnTime": 1668301706,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2202"
      },
      "createdOnTime": 1668302306,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2228"
      },
      "createdOnTime": 1668302906,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2246"
      },
      "createdOnTime": 1668303506,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2251"
      },
      "createdOnTime": 1668304106,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2251"
      },
      "createdOnTime": 1668304706,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2264"
      },
      "createdOnTime": 1668305306,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2280"
      },
      "createdOnTime": 1668305906,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2302"
      },
      "createdOnTime": 1668306506,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2239"
      },
      "createdOnTime": 1668307106,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2250"
      },
      "createdOnTime": 1668307706,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2260"
      },
      "createdOnTime": 1668308306,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2273"
      },
      "createdOnTime": 1668308906,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2284"
      },
      "createdOnTime": 1668309506,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2297"
      },
      "createdOnTime": 1668310107,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2309"
      },
      "createdOnTime": 1668310707,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2241"
      },
      "createdOnTime": 1668311307,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2248"
      },
      "createdOnTime": 1668311907,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2258"
      },
      "createdOnTime": 1668312507,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2285"
      },
      "createdOnTime": 1668313107,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2280"
      },
      "createdOnTime": 1668313707,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2292"
      },
      "createdOnTime": 1668314307,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2332"
      },
      "createdOnTime": 1668314907,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2357"
      },
      "createdOnTime": 1668315507,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2322"
      },
      "createdOnTime": 1668316107,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2333"
      },
      "createdOnTime": 1668316707,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2360"
      },
      "createdOnTime": 1668317307,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2399"
      },
      "createdOnTime": 1668317907,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2397"
      },
      "createdOnTime": 1668318507,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2399"
      },
      "createdOnTime": 1668319108,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2411"
      },
      "createdOnTime": 1668319708,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2424"
      },
      "createdOnTime": 1668320308,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2354"
      },
      "createdOnTime": 1668320908,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2348"
      },
      "createdOnTime": 1668321508,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2339"
      },
      "createdOnTime": 1668322108,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2323"
      },
      "createdOnTime": 1668322708,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2309"
      },
      "createdOnTime": 1668323308,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2289"
      },
      "createdOnTime": 1668323908,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2276"
      },
      "createdOnTime": 1668324508,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2259"
      },
      "createdOnTime": 1668325108,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2168"
      },
      "createdOnTime": 1668325708,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2157"
      },
      "createdOnTime": 1668326308,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2157"
      },
      "createdOnTime": 1668326908,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2153"
      },
      "createdOnTime": 1668327508,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2144"
      },
      "createdOnTime": 1668328109,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2139"
      },
      "createdOnTime": 1668328709,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2138"
      },
      "createdOnTime": 1668329309,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2058"
      },
      "createdOnTime": 1668329909,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2063"
      },
      "createdOnTime": 1668330509,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2071"
      },
      "createdOnTime": 1668331109,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2070"
      },
      "createdOnTime": 1668331709,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2072"
      },
      "createdOnTime": 1668332309,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2074"
      },
      "createdOnTime": 1668332909,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2078"
      },
      "createdOnTime": 1668333509,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2071"
      },
      "createdOnTime": 1668334109,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1991"
      },
      "createdOnTime": 1668334709,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1996"
      },
      "createdOnTime": 1668335309,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1991"
      },
      "createdOnTime": 1668335909,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1993"
      },
      "createdOnTime": 1668336509,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1997"
      },
      "createdOnTime": 1668337110,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1995"
      },
      "createdOnTime": 1668337710,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1997"
      },
      "createdOnTime": 1668338310,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "2003"
      },
      "createdOnTime": 1668338910,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1926"
      },
      "createdOnTime": 1668339510,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1925"
      },
      "createdOnTime": 1668340110,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1924"
      },
      "createdOnTime": 1668340710,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1922"
      },
      "createdOnTime": 1668341310,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1928"
      },
      "createdOnTime": 1668341910,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1925"
      },
      "createdOnTime": 1668342510,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1929"
      },
      "createdOnTime": 1668343110,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1854"
      },
      "createdOnTime": 1668343710,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1858"
      },
      "createdOnTime": 1668344310,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1856"
      },
      "createdOnTime": 1668344911,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1860"
      },
      "createdOnTime": 1668345511,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1867"
      },
      "createdOnTime": 1668346111,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1863"
      },
      "createdOnTime": 1668346711,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1865"
      },
      "createdOnTime": 1668347311,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1865"
      },
      "createdOnTime": 1668347911,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1791"
      },
      "createdOnTime": 1668348511,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1797"
      },
      "createdOnTime": 1668349111,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1806"
      },
      "createdOnTime": 1668349711,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1812"
      },
      "createdOnTime": 1668350311,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1816"
      },
      "createdOnTime": 1668350911,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1828"
      },
      "createdOnTime": 1668351511,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1829"
      },
      "createdOnTime": 1668352111,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1834"
      },
      "createdOnTime": 1668352711,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1764"
      },
      "createdOnTime": 1668353311,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1771"
      },
      "createdOnTime": 1668353912,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1766"
      },
      "createdOnTime": 1668354512,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1769"
      },
      "createdOnTime": 1668355112,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1772"
      },
      "createdOnTime": 1668355712,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1779"
      },
      "createdOnTime": 1668356312,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1784"
      },
      "createdOnTime": 1668356912,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1708"
      },
      "createdOnTime": 1668357512,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1716"
      },
      "createdOnTime": 1668358112,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1728"
      },
      "createdOnTime": 1668358712,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1747"
      },
      "createdOnTime": 1668359312,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1742"
      },
      "createdOnTime": 1668359912,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1743"
      },
      "createdOnTime": 1668360512,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1746"
      },
      "createdOnTime": 1668361112,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1759"
      },
      "createdOnTime": 1668361712,
      "deviceId": "3C:61:05:67:10:F4"
    },
    {
      "device_data": {
        "temp": "1707"
      },
      "createdOnTime": 1668362313,
      "deviceId": "3C:61:05:67:10:F4"
    }
  ],
  "Count": 513,
  "ScannedCount": 513
}

const Rowi_1minute = [
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1931",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669287646
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1931",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669287706
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1931",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669287767
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1931",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669287828
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1925",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669287888
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1925",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669287951
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1925",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669288011
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1925",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669288071
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1925",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669288133
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1918",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669288194
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1918",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669288254
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1912",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669288315
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1918",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669288375
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1912",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669288436
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1912",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669288496
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1912",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669288556
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1912",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669288617
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1906",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669288681
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1906",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669288741
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1906",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669288802
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1906",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669288862
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1906",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669288925
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1906",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669288985
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1900",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669289046
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1900",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669289107
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1900",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669289173
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1893",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669289234
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1900",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669289309
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1893",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669289369
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1893",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669289430
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1893",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669289490
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1893",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669289551
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1887",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669289611
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1887",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669289672
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1887",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669289732
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1887",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669289792
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1881",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669289853
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1887",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669289913
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1881",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669289974
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1881",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669290034
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1881",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669290095
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1881",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669290155
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1875",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669290216
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1875",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669290276
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1875",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669290337
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1875",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669290397
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1875",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669290457
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1875",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669290518
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1868",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669290578
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1875",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669290639
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1868",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669290699
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1868",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669290760
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1868",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669290820
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1868",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669290880
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1868",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669290941
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1868",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669291001
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1862",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669291062
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1862",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669291122
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1862",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669291182
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1862",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669291243
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1856",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669291303
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1856",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669291364
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1856",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669291424
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1856",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669291485
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1850",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669291545
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1856",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669291605
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1856",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669291666
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1856",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669291726
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1850",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669291787
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1850",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669291847
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1850",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669291908
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1850",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669291968
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1850",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669292029
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1850",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669292089
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1843",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669292150
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1843",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669292210
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1843",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669292270
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1843",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669292331
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1843",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669292391
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1843",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669292452
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1837",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669292512
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1837",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669292572
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1837",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669292633
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1837",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669292693
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1837",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669292754
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1837",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669292814
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1837",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669292875
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1837",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669292935
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1831",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669292995
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1831",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669293056
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1831",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669293116
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1831",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669293177
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1831",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669293237
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1831",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669293299
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1831",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669293359
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1831",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669293420
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1825",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669293480
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1825",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669293542
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1825",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669293602
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1825",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669293664
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1825",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669293724
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1818",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669293786
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1818",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669293847
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1818",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669293908
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1818",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669293970
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1818",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669294031
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1818",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669294093
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1818",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669294155
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1812",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669294217
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1812",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669294278
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1812",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669294342
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1812",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669294402
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1806",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669294463
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1806",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669294525
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1806",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669294585
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1806",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669294645
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1800",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669294706
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1800",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669294766
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1800",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669294828
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1800",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669294888
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1800",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669294951
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1793",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669295011
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1793",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669295072
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1793",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669295133
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1793",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669295193
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1793",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669295254
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1793",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669295315
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1787",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669295378
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1787",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669295439
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1787",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669295499
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1787",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669295560
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1787",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669295620
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1787",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669295683
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1787",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669295745
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1781",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669295806
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1781",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669295868
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1781",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669295928
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1781",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669295989
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1781",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669296050
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1781",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669296112
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1781",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669296174
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1781",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669296235
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1781",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669296297
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1775",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669296360
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1775",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669296420
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1775",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669296483
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1775",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669296543
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1775",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669296604
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1775",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669296664
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1775",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669296725
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1775",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669296785
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1775",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669296845
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1775",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669296906
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1775",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669296966
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1768",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669297027
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1768",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669297088
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1768",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669297148
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1768",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669297210
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1768",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669297271
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1768",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669297335
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1768",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669297396
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1768",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669297456
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1768",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669297520
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1768",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669297581
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1762",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669297642
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1762",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669297703
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1762",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669297764
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1762",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669297826
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1762",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669297886
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1756",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669297947
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1756",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669298007
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1756",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669298068
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1756",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669298128
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1750",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669298189
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1750",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669298249
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1750",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669298310
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1750",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669298371
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1750",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669298432
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1750",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669298492
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1750",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669298553
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1743",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669298613
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1743",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669298674
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1743",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669298735
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1743",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669298796
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1743",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669298857
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1743",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669298917
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1737",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669298978
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1737",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669299039
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1737",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669299101
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1737",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669299161
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1737",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669299222
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1737",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669299284
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1737",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669299346
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1737",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669299407
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1737",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669299467
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1737",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669299528
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1731",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669299589
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1731",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669299650
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1731",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669299710
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1737",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669299771
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1731",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669299833
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1731",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669299894
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1737",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669299956
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1731",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669300017
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1731",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669300080
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1731",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669300140
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1731",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669300201
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1731",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669300263
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1731",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669300325
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1725",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669300386
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1725",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669300448
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1725",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669300508
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1725",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669300568
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1725",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669300630
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1725",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669300690
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1725",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669300751
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1725",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669300811
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1718",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669300873
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1718",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669300933
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1718",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669300997
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1725",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669301058
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1718",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669301118
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1718",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669301179
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1718",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669301241
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1718",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669301301
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1712",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669301363
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1712",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669301423
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1712",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669301484
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1712",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669301544
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1712",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669301606
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1706",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669301668
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1706",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669301729
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1706",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669301791
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1706",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669301853
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1706",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669301916
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1706",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669301977
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1700",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669302037
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1706",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669302098
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1700",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669302158
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1700",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669302219
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1700",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669302280
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1700",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669302342
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1700",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669302404
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1700",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669302465
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1700",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669302526
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1700",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669302587
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1700",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669302649
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669302710
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1700",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669302774
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1700",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669302835
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669302896
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669302957
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669303018
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669303079
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1687",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669303140
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669303201
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669303262
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669303322
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669303382
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669303443
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669303503
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669303564
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669303624
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669303684
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669303745
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669303805
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669303865
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669303926
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669303986
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669304047
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669304107
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669304167
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669304228
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669304288
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669304348
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669304409
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669304469
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669304530
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669304590
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669304650
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669304711
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669304771
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669304831
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669304892
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669304952
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669305013
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669305073
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669305133
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669305194
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669305254
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669305314
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669305375
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669305435
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669305496
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669305556
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669305616
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669305677
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669305737
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669305797
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669305858
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669305918
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669305979
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669306039
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669306099
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669306160
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669306220
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669306281
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669306341
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669306401
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669306462
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669306522
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669306583
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669306643
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669306703
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669306764
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669306824
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669306884
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669306945
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669307005
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669307066
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669307126
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669307186
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669307247
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669307307
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669307367
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669307428
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669307488
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669307549
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1637",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669307609
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1637",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669307670
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1637",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669307730
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1631",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669307790
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1637",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669307851
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1631",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669307911
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1631",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669307972
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1631",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669308032
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1631",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669308092
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1631",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669308153
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1631",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669308213
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1625",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669308274
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1625",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669308334
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1625",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669308394
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1625",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669308455
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1625",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669308515
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1618",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669308576
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1625",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669308636
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1618",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669308697
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1618",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669308757
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1618",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669308818
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1618",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669308878
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1618",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669308938
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1618",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669308999
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1618",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669309059
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669309120
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1618",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669309180
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1618",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669309241
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1618",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669309301
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1618",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669309361
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669309422
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669309482
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669309543
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669309603
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1618",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669309663
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669309724
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669309784
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669309844
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669309905
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669309965
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669310026
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669310086
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669310148
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669310209
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669310271
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669310332
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669310393
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669310455
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669310516
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669310577
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669310637
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1606",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669310698
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1606",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669310758
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669310819
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669310879
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669310940
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1606",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669311000
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1606",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669311060
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1606",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669311121
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1606",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669311182
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1606",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669311244
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1606",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669311305
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1606",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669311365
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1606",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669311426
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669311486
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669311547
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669311608
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1618",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669311670
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1618",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669311731
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1618",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669311792
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1618",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669311853
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1618",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669311916
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1618",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669311977
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669312037
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669312098
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1618",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669312158
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1618",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669312220
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669312280
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1618",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669312341
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1618",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669312402
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1618",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669312463
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1618",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669312525
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669312586
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669312647
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669312707
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669312769
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1612",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669312829
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1618",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669312890
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1625",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669312950
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1631",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669313012
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1631",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669313073
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1643",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669313134
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1643",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669313195
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1650",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669313256
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1656",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669313318
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1656",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669313378
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1662",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669313439
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1668",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669313499
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1675",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669313561
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1675",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669313621
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1681",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669313682
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1687",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669313743
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1687",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669313804
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1693",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669313867
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1700",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669313927
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1700",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669313989
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1706",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669314049
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1706",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669314111
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1712",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669314173
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1712",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669314236
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1718",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669314297
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1725",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669314357
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1725",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669314418
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1725",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669314478
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1731",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669314540
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1731",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669314601
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1731",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669314663
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1737",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669314724
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1737",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669314784
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1737",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669314844
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1737",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669314905
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1743",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669314966
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1743",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669315026
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1743",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669315086
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1743",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669315147
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1750",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669315208
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1750",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669315268
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1750",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669315330
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1750",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669315390
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1750",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669315451
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1756",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669315511
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1756",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669315572
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1756",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669315633
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1756",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669315694
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1756",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669315757
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1756",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669315817
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1756",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669315879
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1756",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669315941
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1756",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669316003
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1762",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669316063
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1768",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669316124
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1768",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669316184
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1775",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669316248
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1775",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669316309
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1781",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669316370
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1781",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669316431
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1787",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669316491
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1787",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669316555
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "48",
      "pmom": "0.00",
      "temp": "1787",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669316617
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1781",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669316677
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1781",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669316738
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1775",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669316798
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1775",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669316861
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1781",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669316921
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1781",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669316982
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1775",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669317042
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1775",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669317103
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1775",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669317164
  },
  {
    "device_data": {
      "heat": "0",
      "hhea": "49",
      "pmom": "0.00",
      "temp": "1775",
      "tset": "700",
      "volt": "230.00"
    },
    "createdOnTime": 1669317226
  }
]

const C8_FC = {
  "Items": [
    {
      "device_data": {
        "temp": "2099"
      },
      "createdOnTime": 1653912148,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2103"
      },
      "createdOnTime": 1653912748,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2111"
      },
      "createdOnTime": 1653913348,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2117"
      },
      "createdOnTime": 1653913948,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2121"
      },
      "createdOnTime": 1653914549,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2125"
      },
      "createdOnTime": 1653915149,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2051"
      },
      "createdOnTime": 1653915749,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2053"
      },
      "createdOnTime": 1653916349,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2060"
      },
      "createdOnTime": 1653916949,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2067"
      },
      "createdOnTime": 1653917549,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2071"
      },
      "createdOnTime": 1653918149,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2078"
      },
      "createdOnTime": 1653918749,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2081"
      },
      "createdOnTime": 1653919349,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2006"
      },
      "createdOnTime": 1653919949,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2010"
      },
      "createdOnTime": 1653920549,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2013"
      },
      "createdOnTime": 1653921149,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2014"
      },
      "createdOnTime": 1653921749,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2017"
      },
      "createdOnTime": 1653922350,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2025"
      },
      "createdOnTime": 1653922950,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2029"
      },
      "createdOnTime": 1653923550,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2039"
      },
      "createdOnTime": 1653924150,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1968"
      },
      "createdOnTime": 1653924750,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1971"
      },
      "createdOnTime": 1653925350,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1980"
      },
      "createdOnTime": 1653925950,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1987"
      },
      "createdOnTime": 1653926550,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1989"
      },
      "createdOnTime": 1653927150,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1998"
      },
      "createdOnTime": 1653927750,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2006"
      },
      "createdOnTime": 1653928350,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2015"
      },
      "createdOnTime": 1653928950,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1940"
      },
      "createdOnTime": 1653929551,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1946"
      },
      "createdOnTime": 1653930151,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1959"
      },
      "createdOnTime": 1653930751,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1957"
      },
      "createdOnTime": 1653931351,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1966"
      },
      "createdOnTime": 1653931951,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1976"
      },
      "createdOnTime": 1653932559,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1981"
      },
      "createdOnTime": 1653933159,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1913"
      },
      "createdOnTime": 1653933759,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1922"
      },
      "createdOnTime": 1653934359,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1927"
      },
      "createdOnTime": 1653934959,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1931"
      },
      "createdOnTime": 1653935559,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1936"
      },
      "createdOnTime": 1653936159,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1943"
      },
      "createdOnTime": 1653936759,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1953"
      },
      "createdOnTime": 1653937359,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1956"
      },
      "createdOnTime": 1653937959,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1890"
      },
      "createdOnTime": 1653938559,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1892"
      },
      "createdOnTime": 1653939160,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1905"
      },
      "createdOnTime": 1653939760,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1911"
      },
      "createdOnTime": 1653940360,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1917"
      },
      "createdOnTime": 1653940960,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1930"
      },
      "createdOnTime": 1653941560,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1940"
      },
      "createdOnTime": 1653942160,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1957"
      },
      "createdOnTime": 1653942760,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1896"
      },
      "createdOnTime": 1653943360,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1925"
      },
      "createdOnTime": 1653943960,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1947"
      },
      "createdOnTime": 1653944560,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "1979"
      },
      "createdOnTime": 1653945160,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2014"
      },
      "createdOnTime": 1653945760,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2059"
      },
      "createdOnTime": 1653946360,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2106"
      },
      "createdOnTime": 1653946961,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2078"
      },
      "createdOnTime": 1653947561,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2113"
      },
      "createdOnTime": 1653948161,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2146"
      },
      "createdOnTime": 1653948761,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2177"
      },
      "createdOnTime": 1653949361,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2206"
      },
      "createdOnTime": 1653949961,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2237"
      },
      "createdOnTime": 1653950561,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2270"
      },
      "createdOnTime": 1653951161,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2293"
      },
      "createdOnTime": 1653951761,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2247"
      },
      "createdOnTime": 1653952361,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2274"
      },
      "createdOnTime": 1653952961,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2293"
      },
      "createdOnTime": 1653953561,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2314"
      },
      "createdOnTime": 1653954161,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2337"
      },
      "createdOnTime": 1653954762,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2368"
      },
      "createdOnTime": 1653955362,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2384"
      },
      "createdOnTime": 1653955962,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2395"
      },
      "createdOnTime": 1653956562,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2328"
      },
      "createdOnTime": 1653957162,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2340"
      },
      "createdOnTime": 1653957762,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2363"
      },
      "createdOnTime": 1653958362,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2381"
      },
      "createdOnTime": 1653958962,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2401"
      },
      "createdOnTime": 1653959562,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2411"
      },
      "createdOnTime": 1653960162,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2433"
      },
      "createdOnTime": 1653960762,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2446"
      },
      "createdOnTime": 1653961362,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2385"
      },
      "createdOnTime": 1653961963,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2405"
      },
      "createdOnTime": 1653962563,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2410"
      },
      "createdOnTime": 1653963163,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2419"
      },
      "createdOnTime": 1653963763,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2426"
      },
      "createdOnTime": 1653964363,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2434"
      },
      "createdOnTime": 1653964963,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2441"
      },
      "createdOnTime": 1653965563,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2372"
      },
      "createdOnTime": 1653966163,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2380"
      },
      "createdOnTime": 1653966763,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2390"
      },
      "createdOnTime": 1653967363,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2395"
      },
      "createdOnTime": 1653967963,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2405"
      },
      "createdOnTime": 1653968563,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2412"
      },
      "createdOnTime": 1653969163,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2424"
      },
      "createdOnTime": 1653969763,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2430"
      },
      "createdOnTime": 1653970364,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2354"
      },
      "createdOnTime": 1653970964,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2355"
      },
      "createdOnTime": 1653971564,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2355"
      },
      "createdOnTime": 1653972164,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2360"
      },
      "createdOnTime": 1653972764,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2369"
      },
      "createdOnTime": 1653973364,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2375"
      },
      "createdOnTime": 1653973964,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2373"
      },
      "createdOnTime": 1653974564,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2379"
      },
      "createdOnTime": 1653975164,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2307"
      },
      "createdOnTime": 1653975764,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2304"
      },
      "createdOnTime": 1653976364,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2301"
      },
      "createdOnTime": 1653976964,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2306"
      },
      "createdOnTime": 1653977565,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2313"
      },
      "createdOnTime": 1653978165,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2323"
      },
      "createdOnTime": 1653978765,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2351"
      },
      "createdOnTime": 1653979365,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2293"
      },
      "createdOnTime": 1653979965,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2293"
      },
      "createdOnTime": 1653980565,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2291"
      },
      "createdOnTime": 1653981165,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2299"
      },
      "createdOnTime": 1653981765,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2298"
      },
      "createdOnTime": 1653982365,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2303"
      },
      "createdOnTime": 1653982965,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2312"
      },
      "createdOnTime": 1653983565,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2343"
      },
      "createdOnTime": 1653984165,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2325"
      },
      "createdOnTime": 1653984765,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2331"
      },
      "createdOnTime": 1653985366,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2347"
      },
      "createdOnTime": 1653985966,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2363"
      },
      "createdOnTime": 1653986566,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2374"
      },
      "createdOnTime": 1653987166,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2387"
      },
      "createdOnTime": 1653987766,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2410"
      },
      "createdOnTime": 1653988366,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2444"
      },
      "createdOnTime": 1653988966,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2409"
      },
      "createdOnTime": 1653989566,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2437"
      },
      "createdOnTime": 1653990166,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2439"
      },
      "createdOnTime": 1653990766,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2458"
      },
      "createdOnTime": 1653991366,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2464"
      },
      "createdOnTime": 1653991966,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2473"
      },
      "createdOnTime": 1653992567,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2487"
      },
      "createdOnTime": 1653993167,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2504"
      },
      "createdOnTime": 1653993767,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2434"
      },
      "createdOnTime": 1653994367,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2444"
      },
      "createdOnTime": 1653994967,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2453"
      },
      "createdOnTime": 1653995567,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2462"
      },
      "createdOnTime": 1653996167,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2468"
      },
      "createdOnTime": 1653996767,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2474"
      },
      "createdOnTime": 1653997367,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2471"
      },
      "createdOnTime": 1653997967,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2396"
      },
      "createdOnTime": 1653998567,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2400"
      },
      "createdOnTime": 1653999167,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2405"
      },
      "createdOnTime": 1653999767,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2403"
      },
      "createdOnTime": 1654000368,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2410"
      },
      "createdOnTime": 1654000968,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2415"
      },
      "createdOnTime": 1654001568,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2420"
      },
      "createdOnTime": 1654002168,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2420"
      },
      "createdOnTime": 1654002768,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2342"
      },
      "createdOnTime": 1654003368,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2347"
      },
      "createdOnTime": 1654003968,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2353"
      },
      "createdOnTime": 1654004568,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2356"
      },
      "createdOnTime": 1654005168,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2362"
      },
      "createdOnTime": 1654005768,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2362"
      },
      "createdOnTime": 1654006368,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2362"
      },
      "createdOnTime": 1654006968,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2363"
      },
      "createdOnTime": 1654007568,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2289"
      },
      "createdOnTime": 1654008168,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2290"
      },
      "createdOnTime": 1654008769,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2298"
      },
      "createdOnTime": 1654009369,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2299"
      },
      "createdOnTime": 1654009969,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2296"
      },
      "createdOnTime": 1654010569,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2303"
      },
      "createdOnTime": 1654011169,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2313"
      },
      "createdOnTime": 1654011769,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2244"
      },
      "createdOnTime": 1654012369,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2245"
      },
      "createdOnTime": 1654012969,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2250"
      },
      "createdOnTime": 1654013569,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2264"
      },
      "createdOnTime": 1654014169,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2268"
      },
      "createdOnTime": 1654014769,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2278"
      },
      "createdOnTime": 1654015369,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2292"
      },
      "createdOnTime": 1654015970,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2298"
      },
      "createdOnTime": 1654016570,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2223"
      },
      "createdOnTime": 1654017170,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2232"
      },
      "createdOnTime": 1654017770,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2234"
      },
      "createdOnTime": 1654018370,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2243"
      },
      "createdOnTime": 1654018970,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2248"
      },
      "createdOnTime": 1654019570,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2252"
      },
      "createdOnTime": 1654020170,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2259"
      },
      "createdOnTime": 1654020770,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2267"
      },
      "createdOnTime": 1654021370,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2202"
      },
      "createdOnTime": 1654021970,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2209"
      },
      "createdOnTime": 1654022570,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2215"
      },
      "createdOnTime": 1654023170,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2220"
      },
      "createdOnTime": 1654023771,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2224"
      },
      "createdOnTime": 1654024371,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2232"
      },
      "createdOnTime": 1654024971,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2244"
      },
      "createdOnTime": 1654025571,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2179"
      },
      "createdOnTime": 1654026171,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2192"
      },
      "createdOnTime": 1654026771,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2207"
      },
      "createdOnTime": 1654027371,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2224"
      },
      "createdOnTime": 1654027971,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2243"
      },
      "createdOnTime": 1654028571,
      "deviceId": "EC:94:CB:79:C8:FC"
    },
    {
      "device_data": {
        "temp": "2267"
      },
      "createdOnTime": 1654029171,
      "deviceId": "EC:94:CB:79:C8:FC"
    }
  ],
  "Count": 196,
  "ScannedCount": 196
}

export const ddbMock = {
  // "EC:94:CB:79:C8:D4" : RoomRight,
  // "3C:61:05:67:10:F4" : RoomLeft,
  "C8:C9:A3:C4:04:98" : Rowi_1minute,
  "default" : Rowi_1minute
}

export const chartApiDataCacheMock = {
  "C8:F0:9E:18:0D:00": {
    "y2022": {
      "m10": {
        "d25": [
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1912",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669287628
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669287688
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669287748
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669287810
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669287871
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669287937
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669287997
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669288057
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669288117
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669288177
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669288237
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669288298
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669288360
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669288420
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669288481
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669288542
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669288602
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669288664
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669288725
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669288786
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669288846
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669288910
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669288970
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669289030
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669289095
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669289155
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669289219
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669289279
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669289340
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669289400
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669289460
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669289520
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669289580
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669289642
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669289704
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669289765
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669289825
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669289885
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669289945
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669290006
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669290068
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669290128
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669290189
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669290251
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669290313
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669290375
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669290436
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669290498
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669290559
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669290621
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669290682
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669290745
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669290806
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669290866
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669290927
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669290990
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669291051
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669291113
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669291174
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669291234
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1850",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669291296
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1850",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669291356
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1850",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669291419
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1850",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669291481
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1850",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669291541
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1850",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669291602
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669291665
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669291725
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669291785
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669291846
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669291908
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669291971
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669292031
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669292093
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669292156
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669292217
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669292278
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669292340
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669292402
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669292463
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669292524
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669292587
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669292649
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669292710
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669292772
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669292836
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669292896
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669292958
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669293020
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669293082
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669293143
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669293203
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669293265
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669293326
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669293388
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669293448
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669293510
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669293572
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669293633
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669293695
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669293757
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669293819
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669293879
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669293942
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669294002
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669294062
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669294125
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669294186
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669294248
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669294309
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669294372
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669294434
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669294494
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669294557
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669294618
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669294682
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669294742
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669294804
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669294866
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669294928
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669294988
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669295050
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669295111
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669295174
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669295235
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669295297
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669295360
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669295421
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669295483
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669295545
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669295608
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669295670
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669295731
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669295791
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669295852
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669295914
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669295976
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669296037
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669296100
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669296162
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669296223
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669296286
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669296347
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669296408
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669296471
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669296533
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669296594
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669296656
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669296718
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669296780
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669296842
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669296904
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669296965
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669297027
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669297089
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669297151
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669297214
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669297274
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669297336
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669297396
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669297459
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669297520
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669297582
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669297645
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669297705
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669297767
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669297829
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669297889
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669297950
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669298011
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669298073
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669298135
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669298197
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669298257
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669298319
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669298381
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1768",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669298441
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669298506
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1768",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669298566
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1768",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669298626
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1768",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669298687
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1768",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669298749
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1762",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669298809
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1762",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669298871
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1768",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669298932
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1762",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669298995
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1762",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669299056
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1762",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669299118
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1762",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669299181
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1762",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669299241
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1762",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669299304
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1762",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669299367
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1762",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669299427
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669299489
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669299551
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669299613
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669299674
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669299737
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669299798
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669299860
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669299923
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1750",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669299985
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669300046
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1750",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669300109
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1750",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669300170
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1750",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669300231
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1750",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669300293
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1750",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669300354
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1750",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669300414
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1750",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669300475
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1743",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669300536
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1743",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669300598
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1743",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669300659
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1750",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669300721
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1743",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669300781
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1743",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669300843
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1750",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669300904
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1743",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669300966
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1743",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669301028
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1743",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669301089
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1743",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669301151
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669301214
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "67.87",
              "temp": "1743",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669301276
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669301337
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669301400
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669301462
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669301523
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669301585
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669301647
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669301709
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669301773
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669301834
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669301894
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669301955
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669302018
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669302079
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669302140
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1725",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669302203
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1725",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669302264
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1725",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669302326
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1725",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669302388
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1725",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669302448
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1725",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669302509
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1725",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669302570
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1725",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669302633
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1718",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669302695
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1718",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669302756
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1718",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669302819
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1718",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669302880
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1718",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669302942
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1718",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669303004
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1718",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669303066
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1712",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669303128
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "49",
              "pmom": "0.00",
              "temp": "1718",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669303189
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1712",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669303250
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1712",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669303312
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1712",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669303374
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1712",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669303436
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1712",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669303496
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1712",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669303557
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1706",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669303617
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1712",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669303677
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1712",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669303737
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1706",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669303797
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1712",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669303857
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1712",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669303917
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1712",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669303977
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1706",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669304037
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1706",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669304097
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1706",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669304158
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1712",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669304218
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1706",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669304278
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1706",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669304338
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1706",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669304400
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1706",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669304462
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1706",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669304524
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1706",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669304585
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1706",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669304648
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1706",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669304710
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1706",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669304772
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1706",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669304834
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1706",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669304894
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1700",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669304954
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1700",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669305018
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1706",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669305078
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1700",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669305139
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1700",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669305200
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1700",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669305262
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1700",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669305324
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1700",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669305384
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1700",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669305444
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1700",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669305505
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1693",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669305565
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1700",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669305627
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1693",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669305689
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1693",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669305749
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1693",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669305810
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1693",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669305873
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1693",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669305935
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1693",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669305996
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1693",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669306057
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1693",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669306119
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1693",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669306183
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1687",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669306243
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1687",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669306304
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1687",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669306367
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1687",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669306427
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1687",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669306489
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1687",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669306550
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1681",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669306612
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1681",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669306675
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1681",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669306737
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1681",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669306798
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1681",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669306861
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1675",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669306922
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1675",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669306983
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1675",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669307043
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1668",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669307104
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1668",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669307167
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1668",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669307228
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1668",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669307289
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1668",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669307351
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1668",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669307412
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1662",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669307474
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1662",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669307536
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1662",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669307596
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1662",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669307659
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1662",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669307719
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1656",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669307781
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1656",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669307843
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1656",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669307905
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1656",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669307967
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1656",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669308029
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1656",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669308091
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1656",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669308153
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1656",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669308214
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1656",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669308276
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1650",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669308339
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1650",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669308400
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1650",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669308461
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1650",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669308524
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1650",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669308585
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1650",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669308647
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1650",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669308711
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1650",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669308771
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1650",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669308831
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1650",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669308895
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1650",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669308955
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1643",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669309017
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1643",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669309077
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1643",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669309140
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1643",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669309202
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1643",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669309264
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1643",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669309326
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1643",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669309389
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1643",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669309449
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1643",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669309510
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1643",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669309572
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1643",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669309634
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1643",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669309695
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669309758
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669309819
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669309879
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669309940
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669310002
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669310062
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669310123
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669310185
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669310246
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1631",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669310308
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669310371
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669310431
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1631",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669310493
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669310553
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669310613
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1631",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669310676
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669310737
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669310799
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669310861
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1631",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669310924
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1631",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669310984
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669311048
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1631",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669311108
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669311168
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669311230
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669311292
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1631",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669311354
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669311415
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669311477
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669311541
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669311601
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1643",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669311662
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669311722
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1643",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669311782
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669311844
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669311904
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669311966
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669312027
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1631",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669312090
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1631",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669312150
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1631",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669312212
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1631",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669312273
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1631",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669312335
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1631",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669312396
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1631",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669312456
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1631",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669312517
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1631",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669312579
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1631",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669312639
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1631",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669312699
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669312762
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669312823
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1643",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669312883
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1643",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669312946
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669313008
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669313069
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1631",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669313130
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1631",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669313192
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1631",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669313255
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1631",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669313315
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669313378
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669313439
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1637",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669313501
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1643",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669313564
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1643",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669313624
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1643",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669313687
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "39.35",
              "temp": "1650",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669313748
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1656",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669313811
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1656",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669313871
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1662",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669313933
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1662",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669313995
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1662",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669314057
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1662",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669314119
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1668",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669314179
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1662",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669314240
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1668",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669314304
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1675",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669314364
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1681",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669314427
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1681",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669314488
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1681",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669314550
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1687",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669314611
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1687",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669314674
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1693",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669314735
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1693",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669314797
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1700",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669314860
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1700",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669314921
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1693",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669314984
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1693",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669315044
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1693",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669315107
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1700",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669315169
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1700",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669315229
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1693",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669315289
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1693",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669315351
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1693",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669315413
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1687",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669315473
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1693",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669315536
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1693",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669315596
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1693",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669315658
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1700",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669315720
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1693",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669315782
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1693",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669315844
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1693",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669315904
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1693",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669315966
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1693",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669316028
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1687",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669316090
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1687",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669316150
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1681",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669316214
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1687",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669316274
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1681",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669316335
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1681",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669316398
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1681",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669316459
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1687",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669316520
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1687",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669316583
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "52",
              "pmom": "0.00",
              "temp": "8500",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669316661
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "52",
              "pmom": "2059.75",
              "temp": "1712",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669316721
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "2940.35",
              "temp": "1706",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669316781
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "2963.00",
              "temp": "1706",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669316841
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "877.50",
              "temp": "1706",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669316901
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "870.20",
              "temp": "1706",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669316962
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "865.74",
              "temp": "1706",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669317022
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "865.74",
              "temp": "1706",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669317082
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "864.52",
              "temp": "1706",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669317142
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "859.65",
              "temp": "1706",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669317202
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "868.17",
              "temp": "1706",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669317265
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1712",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669317326
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1725",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669317388
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1725",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669317450
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1725",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669317512
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669317573
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "176.21",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669317633
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669317696
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669317756
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669317817
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669317878
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669317940
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669318003
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669318064
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1743",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669318124
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1743",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669318185
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1743",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669318248
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1743",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669318309
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "93.65",
              "temp": "1743",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669318370
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1750",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669318433
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1743",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669318495
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1750",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669318555
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669318615
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669318678
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669318738
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669318799
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1762",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669318864
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1762",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669318924
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1768",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669318984
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669319045
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669319108
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669319169
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "893.71",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669319230
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669319292
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669319354
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669319415
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669319475
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669319536
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669319598
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669319659
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669319721
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669319784
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "879.52",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669319845
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "882.36",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669319905
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669319967
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669320028
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669320089
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669320150
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669320211
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669320276
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669320336
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669320397
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669320457
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669320518
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669320580
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669320642
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669320703
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669320766
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669320828
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669320889
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669320950
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669321012
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669321074
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669321135
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669321197
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669321259
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669321322
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1850",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669321383
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1850",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669321445
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1850",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669321507
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669321569
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "886.42",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669321629
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669321691
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669321754
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669321814
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669321875
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669321938
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669321999
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669322062
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669322125
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669322185
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669322247
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669322310
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669322370
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669322432
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669322492
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "640.44",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669322554
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669322616
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "788.61",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669322677
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669322739
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669322801
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669322864
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669322925
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669322987
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669323048
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1912",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669323111
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1912",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669323172
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1912",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669323235
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "85.38",
              "temp": "1918",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669323297
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1918",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669323357
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1918",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669323420
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1925",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669323481
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1925",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669323543
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1931",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669323605
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1931",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669323667
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1931",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669323729
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1937",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669323790
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1937",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669323853
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1937",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669323913
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1937",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669323975
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669324037
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669324097
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669324158
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669324219
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669324281
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669324343
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1937",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669324405
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669324466
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669324528
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669324588
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669324649
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669324711
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669324774
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669324834
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669324896
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669324956
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669325018
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669325078
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1962",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669325140
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1968",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669325202
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1968",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669325264
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1968",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669325325
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1975",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669325388
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1975",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669325449
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1975",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669325509
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1975",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669325572
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1981",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669325632
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1981",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669325695
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1981",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669325755
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1987",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669325815
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1987",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669325875
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1987",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669325937
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1993",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669325999
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1993",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669326060
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669326122
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669326184
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669326244
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669326304
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669326367
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669326428
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669326491
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669326551
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669326614
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669326675
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669326737
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669326800
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2018",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669326861
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2018",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669326923
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2025",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669326985
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2025",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669327047
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2025",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669327108
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2031",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669327169
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2031",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669327230
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669327292
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669327353
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669327415
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669327476
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669327538
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669327600
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669327662
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669327724
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669327787
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669327848
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669327910
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669327973
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669328034
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669328095
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669328158
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669328220
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669328281
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2043",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669328344
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2043",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669328404
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2043",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669328466
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669328528
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2043",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669328590
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2043",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669328652
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2043",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669328712
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2043",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669328774
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2043",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669328835
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2043",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669328897
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2043",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669328957
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2043",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669329021
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669329081
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669329144
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669329206
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669329267
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669329332
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2031",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669329393
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2031",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669329453
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2025",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669329513
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2025",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669329576
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2018",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669329636
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2018",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669329698
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2025",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669329761
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2025",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669329821
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2031",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669329882
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669329943
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2043",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669330003
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2043",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669330066
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2050",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669330128
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2050",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669330188
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2050",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669330250
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2056",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669330311
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2056",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669330372
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2056",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669330433
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2056",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669330494
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669330555
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669330615
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669330677
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669330738
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669330800
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "894.93",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669330862
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669330923
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669330986
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669331046
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669331108
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669331168
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669331231
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669331292
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669331354
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669331417
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669331478
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669331540
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669331602
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669331663
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669331725
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669331787
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2056",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669331849
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2056",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669331909
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2056",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669331970
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2056",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669332031
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669332094
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2056",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669332156
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669332216
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669332277
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669332340
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669332401
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669332463
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669332526
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669332587
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669332649
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "899.79",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669332711
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669332774
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2075",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669332835
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2075",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669332897
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2075",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669332958
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2075",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669333018
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2075",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669333080
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "896.55",
              "temp": "2075",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669333142
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669333203
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669333264
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669333324
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669333386
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669333447
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669333509
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "723.14",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669333572
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669333632
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669333694
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669333754
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669333815
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669333877
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669333938
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669334001
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669334062
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669334122
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2093",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669334184
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669334245
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669334307
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669334370
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669334432
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669334494
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669334555
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2093",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669334617
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2093",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669334677
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2093",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669334740
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2093",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669334801
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2093",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669334864
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2093",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669334925
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2093",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669334987
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2093",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669335049
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "890.87",
              "temp": "2100",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669335111
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2093",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669335172
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2093",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669335235
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2100",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669335296
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2100",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669335356
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2093",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669335417
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2100",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669335479
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2100",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669335541
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2100",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669335602
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2100",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669335663
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2100",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669335724
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "49",
              "pmom": "0.00",
              "temp": "2106",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669335785
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2100",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669335847
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2100",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669335909
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2106",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669335969
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2106",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669336029
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2106",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669336090
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "818.26",
              "temp": "2106",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669336152
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669336214
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "892.09",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669336276
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669336336
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669336396
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669336458
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669336521
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669336582
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669336643
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669336704
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669336768
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669336829
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669336892
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669336953
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669337014
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669337075
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669337138
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669337200
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669337261
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669337323
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669337383
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669337444
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669337506
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669337568
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669337628
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669337690
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669337751
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669337812
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669337874
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669337934
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669337995
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669338057
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669338117
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669338179
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669338239
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669338300
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669338363
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669338425
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669338485
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669338548
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669338610
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669338671
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2137",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669338734
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669338796
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2137",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669338858
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2137",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669338919
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2137",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669338981
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2137",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669339042
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2137",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669339106
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2137",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669339167
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2137",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669339228
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2143",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669339289
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2143",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669339350
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2143",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669339411
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669339472
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2143",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669339535
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2143",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669339596
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2143",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669339658
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2143",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669339719
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2143",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669339781
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669339843
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669339904
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669339966
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2143",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669340028
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669340090
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2143",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669340152
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2143",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669340213
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669340275
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669340337
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669340398
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669340461
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669340522
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669340583
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669340646
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669340708
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669340769
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669340830
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669340893
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669340954
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669341018
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669341078
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2162",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669341140
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669341203
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669341265
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2162",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669341326
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2162",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669341386
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2162",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669341447
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2162",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669341508
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2168",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669341570
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2168",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669341632
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2168",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669341695
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2162",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669341756
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2162",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669341818
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2168",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669341879
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2168",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669341941
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2168",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669342003
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2168",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669342063
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2168",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669342124
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2168",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669342185
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2168",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669342246
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2168",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669342309
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2168",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669342369
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2168",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669342431
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2168",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669342494
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2168",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669342555
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2168",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669342617
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2175",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669342680
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2168",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669342740
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2175",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669342803
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2175",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669342864
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2175",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669342926
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2175",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669342989
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2175",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669343050
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2175",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669343112
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2175",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669343173
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2175",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669343236
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2175",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669343296
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2175",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669343358
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2175",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669343421
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2175",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669343482
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2181",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669343542
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "52",
              "pmom": "0.00",
              "temp": "2181",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669343638
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "52",
              "pmom": "0.00",
              "temp": "2181",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669343698
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2181",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669343758
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2181",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669343818
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2181",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669343878
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669343938
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669343998
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669344058
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669344118
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669344179
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669344240
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669344302
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669344363
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669344425
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2200",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669344488
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2200",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669344548
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2200",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669344610
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2200",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669344672
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2206",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669344733
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2206",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669344795
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2206",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669344857
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2206",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669344918
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2206",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669344980
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2212",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669345042
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2212",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669345104
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669345165
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2212",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669345226
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2212",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669345288
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669345350
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669345411
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669345474
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669345536
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669345599
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669345660
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669345722
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669345783
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2212",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669345846
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669345906
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669345968
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2225",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669346028
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669346089
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669346151
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2225",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669346211
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669346272
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669346332
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2225",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669346394
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2225",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669346454
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2225",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669346515
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2225",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669346576
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2225",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669346639
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669346700
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669346760
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669346824
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669346884
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669346944
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669347004
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669347065
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "49",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669347126
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669347189
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669347250
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669347310
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669347374
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669347434
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669347494
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669347556
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669347619
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2243",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669347680
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2243",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669347740
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669347800
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669347861
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669347923
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669347984
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669348045
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669348107
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669348169
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669348230
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669348292
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669348352
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669348414
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669348477
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2243",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669348538
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2243",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669348600
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2243",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669348662
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "49",
              "pmom": "0.00",
              "temp": "2250",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669348723
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2250",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669348785
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2250",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669348846
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2250",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669348908
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2250",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669348971
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669349032
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669349094
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669349156
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669349218
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669349279
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669349342
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669349403
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2250",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669349464
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2250",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669349527
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2250",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669349588
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669349651
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669349711
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2250",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669349774
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2250",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669349835
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2250",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669349896
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2250",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669349959
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2250",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669350020
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669350082
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669350145
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669350206
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2262",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669350266
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669350327
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669350390
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669350450
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669350513
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669350574
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669350636
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2275",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669350697
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669350760
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2275",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669350821
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669350882
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669350945
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669351006
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2287",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669351068
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669351129
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669351192
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669351253
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2287",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669351314
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2287",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669351377
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2293",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669351439
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2287",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669351501
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2293",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669351562
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2293",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669351625
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2293",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669351687
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2293",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669351748
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2293",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669351810
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2293",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669351870
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2300",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669351933
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2300",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669351995
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2300",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669352056
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2293",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669352119
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2293",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669352179
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2293",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669352239
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2293",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669352301
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "893.79",
              "temp": "2293",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669352364
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2293",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669352425
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2293",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669352486
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2287",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669352550
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2287",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669352610
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2287",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669352672
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2287",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669352733
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669352794
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669352856
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669352917
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669352980
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669353048
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669353109
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669353169
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669353229
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669353290
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "68.93",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669353350
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669353410
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2287",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669353473
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2287",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669353535
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669353597
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2275",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669353659
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669353720
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669353782
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2262",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669353845
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2262",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669353906
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2262",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669353967
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669354030
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2262",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669354092
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669354153
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669354215
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669354276
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669354338
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669354401
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669354463
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "882.85",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669354523
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669354586
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669354648
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669354709
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2250",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669354771
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "49",
              "pmom": "0.00",
              "temp": "2250",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669354833
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669354895
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669354956
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669355019
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669355080
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669355142
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669355203
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2262",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669355266
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2262",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669355328
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2262",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669355389
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2262",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669355452
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669355513
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669355575
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669355638
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669355700
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669355760
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669355820
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669355882
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669355944
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "883.25",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669356005
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2275",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669356066
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2275",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669356128
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2275",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669356190
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669356251
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669356315
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2275",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669356375
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669356438
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669356498
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669356561
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669356623
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669356686
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669356747
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669356809
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2262",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669356870
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669356932
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669356994
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669357055
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669357118
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2262",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669357182
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2262",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669357244
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669357304
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669357365
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2262",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669357428
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669357489
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669357551
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669357612
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669357675
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669357736
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669357799
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669357860
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669357921
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669357983
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669358046
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669358106
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669358168
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669358230
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669358291
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669358353
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669358419
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2262",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669358479
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2262",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669358540
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2262",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669358601
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2262",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669358662
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2262",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669358724
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2262",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669358785
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669358846
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669358906
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669358966
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669359029
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2250",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669359089
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2250",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669359150
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2250",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669359210
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2250",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669359270
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2243",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669359331
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2243",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669359393
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2243",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669359455
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2243",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669359516
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669359579
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2243",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669359641
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2243",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669359702
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2243",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669359762
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669359824
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "49",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669359885
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669359948
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669360009
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669360070
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669360132
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669360194
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669360256
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669360319
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669360380
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669360441
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669360504
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669360565
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669360628
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669360688
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2225",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669360751
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2225",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669360812
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2225",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669360875
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2225",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669360937
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669360998
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669361061
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669361122
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669361184
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669361247
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669361307
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2212",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669361369
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2212",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669361431
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2206",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669361493
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2200",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669361556
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2200",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669361618
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669361679
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669361743
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669361804
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669361865
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2181",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669361926
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2175",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669361988
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2175",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669362050
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2168",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669362113
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2168",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669362174
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2162",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669362235
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2162",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669362296
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2162",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669362359
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2162",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669362420
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669362483
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669362545
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669362605
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669362667
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669362730
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669362791
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669362854
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669362916
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669362977
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669363038
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669363101
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669363162
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669363223
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669363286
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669363348
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669363408
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669363472
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669363533
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669363594
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669363655
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2162",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669363718
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2162",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669363780
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2162",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669363840
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2162",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669363903
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2162",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669363964
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669364025
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2162",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669364086
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2162",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669364151
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669364211
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669364272
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669364333
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669364396
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669364458
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669364519
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669364579
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2143",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669364643
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2143",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669364705
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2143",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669364765
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2143",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669364825
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2137",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669364889
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2143",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669364950
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2137",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669365010
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2137",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669365072
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2137",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669365133
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2137",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669365195
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669365258
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2137",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669365318
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2137",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669365380
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2137",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669365442
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2137",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669365504
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2137",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669365565
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2137",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669365628
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669365689
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2137",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669365750
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669365814
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669365876
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669365936
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669366000
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669366061
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669366123
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669366186
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669366246
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669366308
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669366368
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669366431
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669366493
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669366555
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669366615
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669366675
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669366739
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669366799
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669366859
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669366920
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669366983
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669367044
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669367107
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669367169
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669367231
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669367292
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669367355
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669367415
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669367477
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669367540
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669367601
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669367661
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669367723
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2106",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669367785
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669367849
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669367909
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669367970
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669368031
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669368092
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669368154
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669368217
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669368277
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669368339
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2106",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669368401
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2106",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669368463
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2106",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669368524
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2106",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669368584
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2106",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669368646
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2106",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669368707
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2100",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669368770
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2100",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669368831
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2100",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669368893
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2100",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669368955
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2100",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669369017
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2100",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669369078
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2093",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669369138
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2093",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669369202
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2093",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669369262
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2093",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669369322
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2093",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669369383
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "48.25",
              "temp": "2093",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669369446
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2093",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669369506
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2093",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669369568
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2093",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669369630
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669369691
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669369753
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669369816
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669369877
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669369941
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669370002
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669370062
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669370122
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669370186
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669370247
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669370308
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669370369
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669370429
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669370489
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "2122.72",
              "temp": "2075",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669370551
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669370613
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2075",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669370675
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669370743
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669370804
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669370865
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669370925
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2075",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669370986
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669371047
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669371107
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2075",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669371167
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2075",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669371230
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2075",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669371290
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2075",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669371354
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669371415
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669371476
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669371537
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669371597
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669371660
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669371721
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669371782
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669371851
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669371911
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669371971
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669372036
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669372096
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2056",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669372158
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2056",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669372219
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2050",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669372279
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2050",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669372339
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2050",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669372399
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2043",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669372461
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2043",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669372524
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2043",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669372585
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669372646
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669372706
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669372768
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2031",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669372830
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2031",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669372895
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2031",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669372955
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2031",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669373015
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2031",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669373075
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2031",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669373135
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2031",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669373197
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2031",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669373257
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2031",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669373318
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2031",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669373380
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2031",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669373441
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2031",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669373501
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2031",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669373563
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2031",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669373623
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2031",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669373683
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2025",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669373744
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2025",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669373817
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2025",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669373957
          }
        ],
        "d26": [
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2025",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669374019
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2025",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669374079
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2025",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669374163
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2025",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669374223
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2018",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669374283
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2018",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669374343
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2018",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669374403
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2018",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669374463
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2025",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669374523
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2018",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669374583
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2018",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669374643
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2018",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669374703
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2018",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669374763
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2018",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669374823
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2018",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669374884
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2018",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669374944
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2018",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669375004
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2018",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669375064
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2018",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669375124
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2012",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669375184
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2012",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669375244
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2012",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669375307
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669375367
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669375429
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669375490
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669375553
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669375615
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669375676
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669375738
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669375800
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669375861
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669375923
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669375986
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669376046
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669376107
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669376169
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669376231
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669376291
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669376352
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669376413
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669376475
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1993",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669376537
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669376600
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1993",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669376661
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1993",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669376721
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1993",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669376782
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1993",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669376844
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1993",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669376906
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1987",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669376968
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1987",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669377029
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1987",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669377091
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1987",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669377152
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1987",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669377216
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1987",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669377277
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1987",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669377339
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1981",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669377399
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1981",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669377461
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1975",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669377522
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1968",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669377584
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1968",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669377644
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1968",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669377705
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1962",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669377766
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669377827
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669377888
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669377951
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669378012
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669378074
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669378137
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669378199
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669378260
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669378321
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669378384
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669378446
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669378506
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669378569
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669378631
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669378692
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669378753
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669378815
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669378876
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669378937
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669378999
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669379060
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669379121
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669379182
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669379246
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669379306
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669379368
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669379431
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669379492
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669379553
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669379616
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669379677
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669379739
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669379802
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669379863
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669379924
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669379986
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669380048
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669380110
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669380171
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669380232
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669380295
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669380355
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669380416
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669380478
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669380538
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669380600
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669380662
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669380723
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669380785
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669380848
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669380909
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669380971
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669381033
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669381095
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669381156
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669381219
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669381280
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669381342
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669381405
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669381465
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669381527
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669381589
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669381650
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669381710
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669381772
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669381833
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669381896
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1937",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669381957
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1937",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669382019
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1937",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669382082
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1931",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669382142
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1931",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669382202
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1925",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669382265
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1925",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669382326
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1918",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669382387
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1918",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669382447
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1918",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669382509
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1912",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669382572
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1912",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669382633
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1912",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669382694
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1912",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669382755
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1912",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669382816
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1912",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669382878
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669382941
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669383001
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669383062
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669383125
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669383186
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669383247
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669383307
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1912",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669383369
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669383431
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669383492
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669383553
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669383614
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669383677
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669383738
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669383801
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669383863
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669383923
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669383985
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669384046
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669384107
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669384168
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669384228
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669384289
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669384352
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669384413
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669384475
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669384537
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669384597
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669384658
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669384720
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669384781
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669384843
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669384903
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669384963
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669385026
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669385087
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669385148
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669385211
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669385273
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669385334
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669385395
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669385458
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669385520
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669385581
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669385641
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669385703
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669385765
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "49",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669385826
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669385889
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669385950
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669386012
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669386075
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669386135
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669386197
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669386260
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669386322
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669386382
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669386442
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669386504
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669386564
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669386626
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669386686
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669386748
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669386809
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669386871
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669386933
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669386995
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669387057
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669387119
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669387179
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669387240
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669387301
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669387363
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669387425
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669387487
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669387552
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669387612
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669387672
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669387732
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669387794
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669387855
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669387917
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1850",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669387979
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669388040
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669388102
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669388164
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669388225
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669388287
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669388349
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669388410
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669388473
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669388534
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669388596
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669388658
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669388718
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669388780
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669388842
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669388902
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669388963
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669389025
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669389087
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669389149
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669389210
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669389272
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669389336
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669389396
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669389457
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669389520
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669389581
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669389642
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669389705
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669389766
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669389828
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669389890
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669389951
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669390013
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669390075
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669390137
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669390198
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669390261
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669390322
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669390384
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669390446
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669390507
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669390569
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669390630
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669390692
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669390754
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669390817
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669390878
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669390940
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669391001
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669391062
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669391125
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669391185
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669391248
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669391310
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669391370
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669391433
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669391495
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669391556
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669391618
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669391680
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669391742
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669391804
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669391865
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669391927
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669391987
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669392050
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669392112
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669392172
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669392233
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669392294
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669392356
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669392417
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669392478
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669392539
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669392600
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669392661
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669392724
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669392785
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669392847
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669392911
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669392971
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669393033
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669393095
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669393157
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669393218
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669393279
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669393339
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669393401
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669393464
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669393524
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669393586
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669393647
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669393709
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669393771
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669393833
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669393894
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669393956
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669394019
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1768",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669394079
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1768",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669394141
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1768",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669394202
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1768",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669394264
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1762",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669394326
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1768",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669394389
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1768",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669394451
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1762",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669394511
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1762",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669394573
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1762",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669394636
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669394698
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1762",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669394759
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1762",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669394821
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1762",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669394883
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669394944
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669395007
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669395069
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669395130
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669395193
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669395256
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669395316
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669395376
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669395437
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "83.81",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669395500
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669395562
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669395622
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669395684
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669395744
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669395806
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669395869
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669395929
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1762",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669395991
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669396052
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1762",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669396115
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669396176
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669396238
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669396300
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669396362
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669396423
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669396486
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669396547
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1756",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669396609
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1750",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669396671
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1743",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669396733
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1750",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669396794
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1743",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669396856
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1743",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669396918
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1743",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669396980
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1743",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669397042
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1743",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669397103
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1743",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669397165
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1743",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669397225
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669397287
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669397348
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669397412
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669397474
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669397535
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669397597
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669397658
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669397720
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669397782
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669397843
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669397905
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669397966
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669398027
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669398090
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669398151
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669398213
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669398275
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1725",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669398337
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669398398
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669398461
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669398523
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1725",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669398583
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1725",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669398643
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1725",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669398705
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1725",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669398766
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669398827
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1725",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669398889
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669398951
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669399011
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669399072
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669399134
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669399196
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669399257
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669399317
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669399379
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669399439
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669399500
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669399563
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669399624
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "2092.86",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669399686
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "2108.97",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669399749
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "2103.08",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669399810
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "2112.50",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669399870
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "2120.36",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669399931
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669399992
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669400055
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669400117
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669400179
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669400240
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669400302
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669400364
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669400426
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669400487
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669400549
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1725",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669400612
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669400674
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669400735
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669400796
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669400859
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669400921
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669400981
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669401044
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669401105
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669401166
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669401229
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669401291
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669401352
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669401417
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669401477
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669401538
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669401598
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669401660
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669401721
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669401784
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669401845
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "2070.45",
              "temp": "1731",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669401905
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669401967
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669402029
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669402091
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669402152
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669402216
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669402276
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669402338
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669402402
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669402462
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669402524
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1737",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669402585
          }
        ],
        "d24": [
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2018",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669201232
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2018",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669201294
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2018",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669201357
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2018",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669201417
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2018",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669201477
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2012",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669201538
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2012",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669201600
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2012",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669201660
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2012",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669201722
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669201782
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669201845
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2012",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669201906
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669201966
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669202028
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669202089
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669202151
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669202213
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669202275
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669202335
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669202397
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669202458
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669202518
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669202580
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669202641
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669202704
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669202765
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669202828
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1993",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669202888
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1993",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669202950
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1993",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669203010
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1993",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669203072
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1993",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669203132
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1987",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669203193
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1993",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669203255
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1987",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669203317
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1993",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669203378
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1987",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669203442
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1987",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669203502
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1987",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669203565
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1987",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669203625
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1987",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669203688
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1987",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669203750
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1987",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669203812
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1987",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669203873
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1987",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669203934
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1981",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669203994
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1981",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669204054
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1981",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669204117
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1981",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669204178
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1981",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669204240
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1975",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669204302
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1975",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669204362
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1975",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669204424
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1975",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669204487
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1975",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669204548
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1975",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669204609
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1975",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669204669
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1975",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669204732
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1975",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669204794
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1968",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669204855
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1968",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669204918
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1968",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669204980
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1968",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669205040
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "49",
              "pmom": "0.00",
              "temp": "1962",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669205101
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1962",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669205164
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1962",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669205224
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669205286
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1962",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669205349
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669205411
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669205471
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669205535
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669205596
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669205657
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669205719
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669205783
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669205844
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669205904
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669205964
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669206025
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669206086
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669206148
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669206208
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669206271
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669206331
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669206393
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "60.13",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669206454
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669206516
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669206578
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669206640
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669206700
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669206760
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1937",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669206822
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669206883
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1937",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669206944
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1937",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669207007
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1937",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669207068
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1937",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669207129
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1937",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669207192
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1937",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669207254
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1937",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669207315
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1937",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669207377
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1931",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669207438
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1937",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669207500
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1931",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669207562
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1931",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669207623
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1931",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669207684
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1931",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669207746
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1925",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669207807
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1925",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669207870
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1925",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669207932
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1925",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669207993
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1925",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669208056
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1925",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669208117
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1918",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669208180
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1918",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669208241
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1918",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669208302
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1925",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669208362
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1918",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669208425
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1918",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669208487
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1918",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669208548
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1918",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669208611
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1918",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669208672
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1918",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669208735
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1918",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669208795
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1918",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669208856
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1912",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669208918
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1912",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669208981
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1912",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669209041
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1912",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669209104
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1918",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669209164
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1912",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669209228
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1912",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669209288
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1912",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669209348
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1912",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669209409
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1912",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669209470
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1912",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669209532
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669209593
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669209653
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "49",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669209714
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669209776
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669209839
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669209899
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669209961
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669210023
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669210085
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669210147
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669210208
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669210271
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669210332
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669210392
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669210454
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669210516
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669210578
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669210639
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669210702
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669210763
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669210824
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669210888
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669210949
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669211009
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669211071
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669211132
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669211194
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669211257
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669211317
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669211378
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669211439
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669211500
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669211564
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669211624
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669211687
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669211748
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669211810
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669211871
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669211934
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669211995
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669212058
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669212120
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669212180
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669212242
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669212303
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669212364
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669212426
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669212487
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669212548
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669212608
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669212673
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669212733
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669212793
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669212855
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669212916
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669212978
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669213038
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669213100
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669213161
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669213221
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669213284
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669213346
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669213407
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669213469
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669213530
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669213591
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669213653
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669213715
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669213777
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669213839
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669213901
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669213962
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669214024
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669214084
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669214144
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669214206
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669214267
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669214329
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669214392
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669214454
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669214514
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669214577
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669214638
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669214700
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669214762
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669214824
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669214885
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669214947
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669215008
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669215070
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669215133
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669215194
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669215256
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669215318
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669215379
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669215442
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669215503
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669215565
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669215627
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669215689
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669215749
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669215810
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669215871
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669215934
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669215995
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669216057
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669216119
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669216180
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669216242
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669216305
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1862",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669216365
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669216425
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669216488
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669216548
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669216612
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669216672
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669216734
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669216796
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669216857
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669216919
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1850",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669216982
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1850",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669217044
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1850",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669217104
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1850",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669217167
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1850",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669217229
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1850",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669217290
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1850",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669217352
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1850",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669217413
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1850",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669217474
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1850",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669217536
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1850",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669217598
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1850",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669217662
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669217722
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1850",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669217783
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1850",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669217845
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669217905
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669217967
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669218027
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1850",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669218090
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669218151
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669218211
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669218271
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669218334
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669218395
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669218456
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669218519
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669218581
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669218641
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669218703
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669218763
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669218824
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669218884
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669218947
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669219009
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669219070
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669219131
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669219193
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669219255
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669219317
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669219380
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669219441
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669219501
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669219562
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669219625
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669219686
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669219747
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669219810
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669219872
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669219933
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669219994
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669220055
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669220117
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669220179
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669220240
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669220302
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669220364
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669220425
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669220485
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669220546
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669220608
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669220670
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669220732
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669220794
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669220854
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669220915
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669220976
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669221037
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669221099
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669221161
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669221223
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669221285
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669221346
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669221408
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669221468
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669221530
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669221592
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669221654
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669221716
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669221777
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669221838
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669221901
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669221962
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669222024
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669222087
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669222147
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669222209
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669222271
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669222334
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669222394
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669222454
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669222516
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669222578
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669222640
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669222701
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669222764
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669222826
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669222887
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669222948
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669223011
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669223071
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669223132
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669223194
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669223257
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669223318
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669223379
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669223442
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669223503
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669223565
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669223628
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669223689
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669223751
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669223814
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669223874
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669223936
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669223999
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669224059
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669224121
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669224182
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669224244
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669224306
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669224367
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669224429
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669224491
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669224552
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669224616
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669224677
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669224739
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669224799
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669224861
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669224922
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669224982
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669225043
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669225105
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669225167
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669225229
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669225289
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669225352
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669225413
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669225476
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669225538
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669225598
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669225660
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669225722
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669225783
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669225845
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669225907
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669225968
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669226030
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669226092
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "49",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669226153
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669226216
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669226278
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669226339
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669226400
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669226463
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669226524
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669226585
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669226649
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669226711
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669226771
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669226834
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669226895
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669226957
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669227020
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669227080
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669227141
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669227202
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669227262
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669227323
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669227385
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669227447
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669227509
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669227571
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669227632
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669227694
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669227756
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669227817
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669227880
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669227941
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669228002
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669228065
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669228126
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669228189
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669228251
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669228311
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669228373
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669228433
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669228495
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669228556
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669228618
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669228680
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669228741
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669228803
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669228865
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669228927
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669228989
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669229050
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669229113
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669229173
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669229235
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669229297
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669229359
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669229421
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669229483
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669229545
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1775",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669229606
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669229669
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669229730
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669229790
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669229854
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669229915
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669229975
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669230035
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669230096
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669230157
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669230219
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669230282
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669230344
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669230405
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669230465
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669230526
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669230589
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669230649
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669230712
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669230773
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669230833
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669230895
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669230956
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669231018
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669231080
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669231142
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669231205
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669231266
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669231328
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669231390
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669231451
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669231513
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669231575
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669231637
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669231697
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669231757
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669231819
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669231881
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669231943
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669232005
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669232065
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669232128
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669232188
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669232249
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669232311
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669232371
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669232432
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669232495
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669232557
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669232617
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669232677
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669232740
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669232802
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669232865
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669232927
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669232987
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669233050
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669233112
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "49",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669233173
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669233235
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669233298
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669233358
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669233420
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669233482
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1781",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669233543
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669233606
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669233667
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1787",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669233729
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669233790
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1793",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669233854
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669233915
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1800",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669233976
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669234037
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669234101
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669234162
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669234222
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1806",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669234284
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1812",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669234346
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669234408
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "55.99",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669234471
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669234533
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669234594
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669234656
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1818",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669234717
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669234779
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669234841
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669234903
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669234963
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669235026
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669235088
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669235149
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1825",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669235211
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669235272
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1831",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669235335
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669235395
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669235458
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669235520
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669235583
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669235644
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669235705
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669235767
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "49",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669235829
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1837",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669235892
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669235952
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1843",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669236016
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1850",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669236077
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1856",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669236138
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1868",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669236199
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1875",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669236259
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1881",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669236320
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1887",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669236380
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1893",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669236440
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669236502
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1900",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669236565
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1906",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669236626
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1912",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669236690
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1912",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669236751
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1912",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669236812
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1925",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669236874
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1925",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669236935
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "2090.75",
              "temp": "1937",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669236997
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "2090.75",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669237059
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "2106.45",
              "temp": "1975",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669237120
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "2110.77",
              "temp": "2018",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669237183
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "2120.19",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669237245
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2106",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669237310
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669237370
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669237430
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669237492
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669237554
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669237615
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669237678
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669237738
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669237801
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669237862
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669237922
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669237985
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669238045
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669238106
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669238168
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669238229
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2106",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669238289
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2106",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669238351
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2106",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669238413
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2106",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669238474
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669238536
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669238596
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669238657
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669238720
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669238781
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669238845
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669238906
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669238966
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2137",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669239028
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669239088
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669239150
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "71.69",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669239213
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2143",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669239273
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669239336
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669239397
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669239458
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669239521
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2162",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669239583
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669239644
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669239706
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669239768
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669239830
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669239893
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2162",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669239953
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2162",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669240015
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2168",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669240079
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2168",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669240139
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2175",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669240201
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2181",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669240263
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669240326
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669240387
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2200",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669240448
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669240509
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2200",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669240571
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2206",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669240634
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2206",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669240694
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669240757
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669240819
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669240880
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669240941
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2200",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669241002
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2206",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669241062
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2206",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669241123
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2212",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669241186
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2212",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669241247
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669241309
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669241371
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669241434
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2225",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669241495
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669241555
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669241618
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2262",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669241679
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2262",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669241741
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2243",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669241803
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2243",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669241865
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2262",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669241926
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669241989
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2250",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669242050
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2250",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669242112
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2243",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669242174
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2243",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669242234
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669242296
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669242359
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2225",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669242420
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669242482
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669242543
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669242606
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669242667
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669242727
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2225",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669242790
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2212",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669242850
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2200",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669242912
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669242972
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2206",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669243033
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2206",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669243094
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2206",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669243156
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2206",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669243217
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2212",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669243280
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669243341
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669243402
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2225",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669243465
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669243527
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2212",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669243588
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2200",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669243650
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669243712
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2200",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669243774
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669243835
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2200",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669243896
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669243958
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669244019
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669244082
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2181",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669244143
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2181",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669244205
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2175",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669244269
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2175",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669244329
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2175",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669244391
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2181",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669244452
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2175",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669244513
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2181",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669244574
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669244635
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669244695
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669244756
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669244819
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669244880
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669244941
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669245004
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669245065
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669245126
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669245187
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669245249
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669245310
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669245371
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "48",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669245432
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669245493
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669245555
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "49",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669245616
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "85.73",
              "temp": "2181",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669245680
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669245740
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669245802
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669245863
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2200",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669245926
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2200",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669245987
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669246049
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669246112
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2206",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669246173
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2206",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669246233
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2206",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669246296
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2206",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669246358
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2206",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669246418
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2206",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669246478
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2200",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669246541
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2200",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669246603
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2200",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669246665
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669246726
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2200",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669246788
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "52",
              "pmom": "0.00",
              "temp": "8500",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669246881
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "52",
              "pmom": "0.00",
              "temp": "2143",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669246942
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669247002
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669247062
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2093",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669247122
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669247182
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669247242
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669247302
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669247362
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669247422
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669247483
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669247544
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669247605
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669247665
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669247726
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669247788
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669247849
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2093",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669247910
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2106",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669247971
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669248033
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669248095
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669248156
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669248216
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2168",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669248278
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2181",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669248340
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669248401
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2200",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669248463
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2200",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669248525
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2200",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669248586
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2200",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669248648
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2206",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669248708
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2206",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669248770
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2212",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669248831
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669248893
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669248955
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669249016
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669249078
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669249141
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669249202
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2225",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669249264
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2225",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669249326
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669249387
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669249448
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669249510
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669249571
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669249633
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2243",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669249695
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669249756
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669249818
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2275",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669249881
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669249941
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669250001
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2250",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669250062
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2250",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669250124
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2250",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669250185
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2250",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669250246
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669250308
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669250370
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669250431
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2262",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669250494
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669250556
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2275",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669250617
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2275",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669250679
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2275",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669250741
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2275",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669250802
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669250864
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669250927
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669250988
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669251049
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669251111
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2287",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669251173
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2287",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669251234
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669251297
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2287",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669251358
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2287",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669251421
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2287",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669251483
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2287",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669251544
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2293",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669251604
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2287",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669251665
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2293",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669251727
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2293",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669251790
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2293",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669251850
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2293",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669251913
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2300",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669251974
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2300",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669252035
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2300",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669252097
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2300",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669252158
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2300",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669252221
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2300",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669252282
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2306",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669252344
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2306",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669252405
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2312",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669252468
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2312",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669252530
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2318",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669252590
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2318",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669252652
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2318",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669252714
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2318",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669252775
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2325",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669252836
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2325",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669252900
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "48",
              "pmom": "0.00",
              "temp": "2325",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669252960
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2325",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669253022
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2325",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669253083
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2325",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669253145
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2331",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669253207
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2331",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669253268
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2331",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669253331
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2325",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669253392
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2331",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669253455
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2356",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669253516
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2393",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669253577
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2406",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669253641
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2406",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669253701
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2400",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669253762
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2393",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669253825
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2387",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669253885
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2381",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669253946
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2375",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669254008
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2368",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669254069
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2368",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669254132
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2368",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669254193
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2362",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669254254
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2362",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669254317
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2362",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669254378
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2362",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669254440
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2362",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669254502
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2350",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669254564
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2350",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669254626
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2356",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669254686
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2362",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669254750
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2362",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669254810
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2362",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669254872
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2356",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669254935
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2356",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669254996
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2356",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669255057
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2356",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669255119
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2356",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669255181
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2356",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669255242
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2356",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669255304
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2356",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669255366
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2356",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669255427
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2362",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669255490
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2362",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669255553
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2362",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669255613
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2356",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669255675
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2362",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669255737
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2362",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669255799
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2362",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669255860
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2362",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669255923
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2362",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669255985
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2362",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669256046
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2368",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669256108
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2362",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669256170
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2362",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669256231
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2356",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669256293
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2356",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669256355
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2356",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669256417
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2350",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669256477
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2350",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669256538
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2350",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669256599
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2350",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669256660
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2356",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669256722
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2356",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669256784
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2350",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669256846
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2350",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669256907
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2343",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669256971
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2343",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669257031
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2343",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669257093
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2337",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669257153
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2343",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669257217
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2337",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669257278
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2337",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669257340
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2337",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669257401
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2343",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669257463
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2343",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669257524
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2343",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669257589
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2343",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669257649
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2350",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669257709
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2350",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669257773
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2350",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669257835
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2356",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669257895
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2356",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669257957
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2356",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669258017
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2356",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669258077
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2356",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669258140
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2356",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669258202
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2368",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669258263
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "49",
              "pmom": "0.00",
              "temp": "2368",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669258325
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2368",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669258386
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2375",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669258447
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2375",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669258507
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2381",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669258571
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2387",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669258631
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2393",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669258691
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2393",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669258751
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2400",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669258814
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2406",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669258875
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2406",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669258937
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2412",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669259000
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2412",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669259061
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2418",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669259123
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2425",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669259185
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2431",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669259247
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2437",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669259307
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2437",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669259369
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2443",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669259431
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2450",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669259492
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2456",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669259555
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2462",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669259616
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2462",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669259679
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2468",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669259741
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2468",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669259802
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2475",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669259864
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2481",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669259927
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2475",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669259988
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2475",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669260049
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2475",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669260112
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2487",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669260174
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2487",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669260235
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2493",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669260298
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2487",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669260359
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2493",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669260422
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2493",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669260483
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2475",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669260546
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2468",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669260606
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2443",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669260666
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2437",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669260728
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2431",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669260790
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2431",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669260851
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2425",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669260911
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2425",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669260972
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2425",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669261035
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2431",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669261095
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2431",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669261156
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2431",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669261218
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2431",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669261281
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2431",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669261342
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2437",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669261404
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2443",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669261464
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2450",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669261525
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2443",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669261585
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2450",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669261648
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2437",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669261709
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2425",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669261770
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2425",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669261830
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2418",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669261891
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2418",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669261953
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2418",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669262013
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2418",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669262076
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2412",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669262136
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2412",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669262197
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2412",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669262258
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2412",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669262320
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2412",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669262381
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2412",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669262444
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2412",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669262504
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2418",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669262566
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2418",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669262626
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2418",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669262688
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2418",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669262749
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2418",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669262811
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2418",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669262875
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2418",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669262936
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2425",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669262997
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "49",
              "pmom": "0.00",
              "temp": "2425",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669263059
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2431",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669263121
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2431",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669263183
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2431",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669263245
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2443",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669263305
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2450",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669263368
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2443",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669263429
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2443",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669263490
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2443",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669263553
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2450",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669263613
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2456",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669263674
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2456",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669263735
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2462",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669263798
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2468",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669263859
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2468",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669263920
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2462",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669263984
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2462",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669264044
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2462",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669264104
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2462",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669264165
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2462",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669264228
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2456",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669264289
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2456",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669264351
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2450",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669264413
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2450",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669264474
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2450",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669264535
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2443",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669264595
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2443",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669264655
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2437",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669264717
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2437",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669264779
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2431",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669264840
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2431",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669264904
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2431",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669264965
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2437",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669265026
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2443",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669265088
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2450",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669265151
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2456",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669265211
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2462",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669265275
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2475",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669265335
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2475",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669265397
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2481",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669265458
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2493",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669265521
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2506",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669265583
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2512",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669265644
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2518",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669265707
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2525",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669265769
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2531",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669265830
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2537",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669265892
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2543",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669265952
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2543",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669266013
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2550",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669266075
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2556",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669266137
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2562",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669266199
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2568",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669266260
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2575",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669266322
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2581",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669266384
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2581",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669266447
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2581",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669266507
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2593",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669266569
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2593",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669266631
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2600",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669266693
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2587",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669266756
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2581",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669266816
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2587",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669266880
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2587",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669266941
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2587",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669267002
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2593",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669267065
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "60.10",
              "temp": "2593",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669267125
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2593",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669267187
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2587",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669267250
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2587",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669267311
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2587",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669267372
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2581",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669267436
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2575",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669267496
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2568",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669267559
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2568",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669267620
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2556",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669267683
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2556",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669267744
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2550",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669267804
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2543",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669267865
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2537",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669267926
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2531",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669267989
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2531",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669268049
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2525",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669268112
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2518",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669268174
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2512",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669268235
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2512",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669268296
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2512",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669268359
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2512",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669268420
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2512",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669268481
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2512",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669268544
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2518",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669268606
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2518",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669268667
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2518",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669268730
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2512",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669268790
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2506",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669268852
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2500",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669268915
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2500",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669268976
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2493",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669269038
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2493",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669269100
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2487",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669269162
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2481",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669269223
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2481",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669269283
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2481",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669269346
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2481",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669269406
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2475",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669269467
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2475",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669269528
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2468",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669269590
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2462",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669269652
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2462",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669269714
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2462",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669269775
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2468",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669269835
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2493",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669269896
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2518",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669269958
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2500",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669270019
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2500",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669270081
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2500",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669270143
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2493",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669270205
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2481",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669270265
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2475",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669270326
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2450",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669270389
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2425",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669270449
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2418",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669270510
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2406",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669270571
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2393",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669270634
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2387",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669270694
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2393",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669270756
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2387",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669270817
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2381",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669270880
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2375",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669270941
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2368",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669271002
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2362",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669271064
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2356",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669271126
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2350",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669271187
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2350",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669271249
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2343",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669271311
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2350",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669271371
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2350",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669271431
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2350",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669271493
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2343",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669271555
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2337",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669271617
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2337",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669271679
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2325",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669271741
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2325",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669271802
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2318",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669271864
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2318",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669271926
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2312",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669271988
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "126.18",
              "temp": "2312",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669272050
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2306",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669272112
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2300",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669272173
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2300",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669272235
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2300",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669272297
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2306",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669272359
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2300",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669272419
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2306",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669272481
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2306",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669272543
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2300",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669272605
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2300",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669272668
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2287",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669272728
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2287",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669272790
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2293",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669272852
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2293",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669272913
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2287",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669272975
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669273036
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669273096
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2281",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669273158
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2275",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669273220
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669273280
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669273343
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669273404
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2262",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669273466
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669273528
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669273589
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669273651
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2250",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669273713
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2243",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669273775
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2243",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669273835
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2243",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669273899
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669273959
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669274021
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669274081
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669274141
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669274202
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669274264
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2231",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669274326
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2225",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669274387
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669274449
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2225",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669274512
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669274574
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669274634
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669274696
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669274758
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2212",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669274819
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2212",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669274879
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2225",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669274941
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2218",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669275001
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2212",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669275061
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2212",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669275124
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2212",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669275184
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2206",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669275246
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2206",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669275308
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2206",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669275369
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2200",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669275431
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2193",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669275494
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669275555
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669275615
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669275677
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2181",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669275739
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669275801
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2181",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669275861
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2175",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669275923
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2181",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669275985
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2181",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669276045
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2181",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669276107
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2181",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669276169
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2181",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669276231
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669276292
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2181",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669276355
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2181",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669276415
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2175",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669276477
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2175",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669276538
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2181",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669276601
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2175",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669276662
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2168",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669276722
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669276783
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669276846
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669276907
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669276968
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669277031
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669277092
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669277153
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669277217
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669277277
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669277340
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669277401
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669277463
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669277526
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669277588
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2162",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669277648
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2162",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669277710
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2168",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669277772
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2168",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669277834
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2168",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669277895
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "49",
              "pmom": "0.00",
              "temp": "2162",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669277958
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2150",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669278020
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2143",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669278080
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2137",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669278143
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669278204
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669278266
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669278328
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669278389
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2137",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669278451
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669278513
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669278575
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669278635
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669278695
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669278756
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669278817
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669278879
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669278941
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669279002
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669279065
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "74.57",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669279126
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669279188
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669279251
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2106",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669279312
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669279373
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669279436
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669279498
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2137",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669279558
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669279621
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2256",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669279682
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2268",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669279744
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2237",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669279805
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2212",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669279867
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2187",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669279930
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2175",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669279990
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2168",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669280052
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2156",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669280115
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2143",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669280176
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2137",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669280236
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2131",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669280299
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2125",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669280359
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669280420
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2118",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669280482
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2112",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669280543
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2100",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669280603
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2093",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669280665
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669280727
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669280788
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2075",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669280850
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669280913
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669280973
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669281034
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2075",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669281095
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669281158
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2081",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669281220
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2087",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669281280
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2100",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669281343
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2093",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669281404
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669281467
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669281528
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2056",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669281590
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669281652
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669281714
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669281774
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669281835
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2056",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669281897
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669281959
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669282020
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669282083
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669282144
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669282206
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669282268
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2075",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669282328
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669282390
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2075",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669282450
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669282510
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2075",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669282571
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669282632
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2068",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669282694
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2056",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669282756
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669282817
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2062",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669282879
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2056",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669282941
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2056",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669283003
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2050",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669283065
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2050",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669283126
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2043",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669283186
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2043",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669283247
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669283309
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669283371
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2037",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669283433
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2031",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669283495
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2031",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669283557
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2031",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669283618
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "49",
              "pmom": "0.00",
              "temp": "2025",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669283679
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2025",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669283741
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2025",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669283802
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2018",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669283863
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2025",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669283924
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2018",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669283986
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2018",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669284047
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2012",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669284108
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2012",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669284171
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2012",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669284233
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2012",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669284295
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2012",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669284355
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669284418
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669284479
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "2006",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669284540
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669284603
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669284666
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669284726
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669284786
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1993",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669284849
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669284911
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669284971
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2000",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669285034
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1993",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669285095
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1993",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669285157
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1987",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669285219
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1987",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669285279
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1987",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669285341
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1981",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669285402
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1981",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669285464
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1981",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669285526
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1968",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669285588
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1968",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669285649
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1962",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669285712
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1962",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669285774
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669285834
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669285894
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669285957
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669286018
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669286079
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669286143
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669286204
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669286264
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669286326
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1950",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669286386
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669286448
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669286509
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669286571
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1943",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669286634
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1937",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669286694
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "55.97",
              "temp": "1937",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669286756
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1937",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669286819
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1937",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669286879
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1937",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669286943
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "52",
              "pmom": "0.00",
              "temp": "8500",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669287077
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "52",
              "pmom": "0.00",
              "temp": "2206",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669287137
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2100",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669287200
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "2012",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669287261
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1975",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669287321
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "50",
              "pmom": "0.00",
              "temp": "1956",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669287382
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1937",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669287445
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1925",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669287508
          },
          {
            "device_data": {
              "heat": "1",
              "hhea": "51",
              "pmom": "0.00",
              "temp": "1918",
              "tset": "11000",
              "volt": "230.00"
            },
            "createdOnTime": 1669287568
          }
        ]
      }
    }
  }
}
